import React, { createContext, useState, ReactNode } from 'react';
import { initialManagerListState, initialManagerListStatewithQualities, initialManagerState, initialManagerStatewithqualities, initialReducedManagerListStatewithQualities, initialReducedManagerTypeWithQualityState } from '../static/types/objectInitialState';
import { CompanyNameType } from '../static/types/commonTypes/companyNameType';
import { StatusSignatureType } from '../static/types/commonTypes/statusSignatureType';
import { TheSocietyType } from '../static/types/commonTypes/theSocietyType';
import { HeadOfficeAddressType } from '../static/types/commonTypes/headOfficeAddressType';
import { companyNameInitialState, officiantInitialState, tribunalInitialState } from '../static/initialState/commonInitialState/companyNameInitialState';
import { statusSignatureWithoutPlaceInitialState } from '../static/initialState/commonInitialState/statusSignatureInitialState';
import { theSocietyFixedCapitalInitialState } from '../static/initialState/commonInitialState/theSocietyInitialState';
import { headOfficeAddressInitialState } from '../static/initialState/commonInitialState/headOfficeAddressInitialState';
import { Clause } from '../static/types/clauseTypes/clauseType';
import { clauseinitial } from '../static/types/clauseTypes/clauseInitialState';
import { ManagerWithRepresentativeType } from '../static/types/limited-company-creation/managerWithRepresentativeType';
import { managerListWithRepresentativeInitalState, managerWithRepresentativeInitalState } from '../static/initialState/limited-company-creation/managerWithRepresentativeInitialState';
import { admissionToMeetingType } from '../static/types/commonTypes/admissionToMeetingType';
import { initialAdmissionToMeetingState } from '../static/initialState/commonInitialState/admissionToMeetingInitialState';
import { CouncilMeetingType } from '../static/types/limited-company-creation/councilMeetingType';
import { councilMeetingInitialState } from '../static/initialState/limited-company-creation/councilMeetingInitialState';
import { identityInitialState } from '../static/initialState/limited-company-creation/identityInitialState';
import { IdentityType } from '../static/types/limited-company-creation/identityType';
import { HeritierType, IndividualPersonType } from '../static/types/commonTypes/individualType';
import { heritierIndividualState, initialIndividualState } from '../static/initialState/commonInitialState/individualInitialState';
import { ManagerType, ManagerTypeWithQualite, ReducedManagerTypeWithQuality } from '../static/types/commonTypes/managerType';
import { DecisionType } from '../static/types/commonTypes/decisionType';
import { decisionInitialState, decisionWithEffectiveDateInitialState, durationInitialState } from '../static/initialState/commonInitialState/decisionInitialeState';
import { LegalEntityType, LegalEntityTypeOfficiant, Tribunal } from '../static/types/commonTypes/legalEntityType';
import { initialLegalEntityState } from '../static/initialState/commonInitialState/legalEntityInitalState';
import { AddressType } from '../static/types/commonTypes/addressType';
import { addressInitialState } from '../static/initialState/commonInitialState/addressInitialState';
import { DateType, DateTypeDeces, DateTypesignature } from '../static/types/commonTypes/dateType';
import { dateInitialState, dateInitialStateDeces, dateInitialStatesignature, singleDateInitialState } from '../static/initialState/commonInitialState/dateInitialState';
import { initialReducedIndividualState } from '../static/initialState/commonInitialState/initialReducedIndividualState';
import { initialReducedLegalEntityState } from '../static/initialState/commonInitialState/initialReducedLegalEntityState';
import { ReducedManagerType } from '../static/types/commonTypes/reducedManagerType';
import { initialReducedManagerState } from '../static/initialState/commonInitialState/initialReducedManagerState';
import { LiquidatorManagerType } from '../static/types/creationCloture/liquidatorManagerType';
import { ReducedLegalEntityType } from '../static/types/commonTypes/reducedLegalEntityType';
import { LeaderChangeType } from '../static/types/commonTypes/leaderChangeType';
import { leaderChangeInitialState } from '../static/initialState/commonInitialState/leaderChangeInitialState';
import { ChangeSocialObjectType } from '../static/types/changeSocialObjective/changeSocialObjectType';
import { initialChangeSocialObjectState } from '../static/initialState/changeSocialObject/initialChangeSocialObjectState';
import { PartnerChangeType } from '../static/types/commonTypes/partnerChangeType';
import { partnerChangeInitialState } from '../static/initialState/commonInitialState/partnerChangeInitialState';
import { initialDescriptionTextState } from '../static/initialState/commonInitialState/initialDescriptionTextState';
import { DescriptionTextType } from '../static/types/commonTypes/descriptionTextType';
import { DecisionWithQualityType } from '../static/types/commonTypes/decisionWithQualityType';
import { decisionWithQualityAndEffictiveDateState, decisionWithQualityState } from '../static/initialState/commonInitialState/decisionWithQualityState';
import { SigningOfTheStatusType } from '../static/types/commonTypes/signingOfTheStatusType';
import { initialSigningOfTheStatusState } from '../static/initialState/commonInitialState/initialSigningOfTheStatusState';
import { TaxServiceRegistrationType } from '../static/types/commonTypes/taxServiceRegistrationType';
import { initialTaxServiceRegistrationState } from '../static/initialState/commonInitialState/initialTaxServiceRegistrationState';
import { RegistrationNoticesType } from '../static/types/commonTypes/registrationNoticesType';
import { initialRegistrationNoticesState } from '../static/initialState/commonInitialState/initialRegistrationNoticesState';
import { DurationManagementType } from '../static/types/commonTypes/durationManagementType';
import { DateOfBirthAndCityType } from '../static/types/commonTypes/dateOfBirthAndCity';
import { initialDateOfBirthAndCityState } from '../static/initialState/commonInitialState/initialDateOfBirthAndCityState';
import { AffectedIndividualsType } from '../static/types/commonTypes/affectedIndividualsType';
import { initialAffectedIndividualsState } from '../static/initialState/commonInitialState/initialAffectedIndividualsState';
import { IndividualWithBirthNameType } from '../static/types/commonTypes/individualWithBirthNameType';
import { initialIndividualWithBirthNameState } from '../static/initialState/commonInitialState/initialIndividualWithBirthNameState';
import { textAreaInitalState, TextareaType } from '../static/types/commonTypes/textAreaType';
import { DeathRelatedInfoType } from '../static/types/commonTypes/deathRelatedInfoType';
import { initialDeathRelatedInfoState } from '../static/initialState/commonInitialState/initialDeathRelatedInfoState';
import { NewNameType } from '../static/types/commonTypes/newNameType';
import { initialNewNameState } from '../static/initialState/commonInitialState/initialNewNameState';
import { ReducedIndividualPersonType } from '../static/types/commonTypes/reducedIndividualPersonType';
import { MariageContractType } from '../static/types/commonTypes/mariageContractType';
import { IndividualWithFamilySituationType } from '../static/types/commonTypes/individualWithFamilySituationType';
import { NotaryContactType } from '../static/types/commonTypes/notaryContactType';
import { RegistrationReferenceType } from '../static/types/commonTypes/registrationReferenceType';
import { registrationReferenceInitialState } from '../static/initialState/commonInitialState/registrationReferenceInitialState';
import { notaryContactInitialState } from '../static/initialState/commonInitialState/notaryContactInitialState';
import { individualWithFamilySituationInitialState } from '../static/initialState/commonInitialState/individualWithFamilySituationInitialState';
import { mariageContractInitialState } from '../static/initialState/commonInitialState/mariageContractInitialState';
import { IndividualWithProfessionType } from '../static/types/commonTypes/individualWithProfessionType';
import { PreviousMaritalRegimeType } from '../static/types/commonTypes/previousMaritalRegimeType';
import { individualWithProfessionInitialState } from '../static/initialState/commonInitialState/individualWithProfessionInitialState';
import { previousMaritalRegimeInitialState } from '../static/initialState/commonInitialState/previousMaritalRegimeInitialState';
import { LogoType } from '../static/types/commonTypes/logoType';
import { Annonce } from '../models/AnnonceModel';
import { TabStypeItem } from '../models/typeAnnonce';
import { set } from 'date-fns';
import { n } from 'framer-motion/dist/types.d-Bq-Qm38R';
import { UserModel } from '../models/UserModel';

// Définir le type du context

export type CapitalType = { capital: number }


export interface AppContextType {

  authenticatedUser: UserModel | null
  setAuthenticatedUser: React.Dispatch<React.SetStateAction<UserModel | null>>


  currentAnnonceId: number | null;
  setCurrentAnnonceId: React.Dispatch<React.SetStateAction<number | null >>;

  userAnnonces: Annonce[];
  setUserAnnonces: React.Dispatch<React.SetStateAction<Annonce[]>>;

  // Discount Id
  discountId: number | null;
  setDiscountId: React.Dispatch<React.SetStateAction<number | null>>;

  // Discount
  discountAmount: number;
  setDiscountAmount: React.Dispatch<React.SetStateAction<number>>;

  // autoDiscount
  autoDiscount: number;
  setAutoDiscount: React.Dispatch<React.SetStateAction<number>>;

  // Draft
  lastTab: string;
  setLastTab: React.Dispatch<React.SetStateAction<string>>;

  draftFormData: string;
  setDraftFormData: React.Dispatch<React.SetStateAction<string>>;

  // support de presse
  pressSupportPostalCode: string;
  setPressSupportPostalCode: React.Dispatch<React.SetStateAction<string>>;

  // additive / corrective announcement
  currentAnnoucement: Annonce | null;
  setCurrentAnnoucement: React.Dispatch<React.SetStateAction<Annonce | null>>;

  announcementTypeList: TabStypeItem[];
  setAnnouncementTypeList: React.Dispatch<React.SetStateAction<TabStypeItem[]>>;

  selectedType: TabStypeItem | null;
  setSelectedType: React.Dispatch<React.SetStateAction<TabStypeItem | null>>;

  
  activeIndex: number,
  setActiveIndex: React.Dispatch<React.SetStateAction<number>>;
  checkedIndex: number,
  setCheckedIndex: React.Dispatch<React.SetStateAction<number>>;

  pressSupportCity: string;
  setPressSupportCity: React.Dispatch<React.SetStateAction<string>>;

  // Registration Notices
  registrationNotices: RegistrationNoticesType;
  setRegistrationNotices: React.Dispatch<React.SetStateAction<RegistrationNoticesType>>;
  registrationNoticesValidity: boolean;
  setRegistrationNoticesValidity: React.Dispatch<React.SetStateAction<boolean>>;
  registrationNoticesChecked: boolean;
  setRegistrationNoticesChecked: React.Dispatch<React.SetStateAction<boolean>>;

  companyName: CompanyNameType;
  setCompanyName: React.Dispatch<React.SetStateAction<CompanyNameType>>;
  companyNameValidity: boolean;
  setCompanyNameValidity: React.Dispatch<React.SetStateAction<boolean>>;
  companyNameChecked: boolean;
  setCompanyNameChecked: React.Dispatch<React.SetStateAction<boolean>>;

  legalEntityofficiant: LegalEntityTypeOfficiant,
  setlegalEntityofficiant: React.Dispatch<React.SetStateAction<LegalEntityTypeOfficiant>>;
  companyNameofficiant: CompanyNameType;
  setcompanyNameofficiant: React.Dispatch<React.SetStateAction<CompanyNameType>>;

  Tribunal: Tribunal,
  setTribunal: React.Dispatch<React.SetStateAction<Tribunal>>;

  mode: LegalEntityTypeOfficiant,
  setmode: React.Dispatch<React.SetStateAction<LegalEntityTypeOfficiant>>;

  heritier: HeritierType,
  setheritier: React.Dispatch<React.SetStateAction<HeritierType>>;


  companyNameUpdate: CompanyNameType;
  setCompanyNameUpdate: React.Dispatch<React.SetStateAction<CompanyNameType>>;
  companyNameUpdateValidity: boolean;
  setCompanyNameUpdateValidity: React.Dispatch<React.SetStateAction<boolean>>;
  companyNameUpdateChecked: boolean;
  setCompanyNameUpdateChecked: React.Dispatch<React.SetStateAction<boolean>>;

  statusSignature: StatusSignatureType;
  setStatusSignature: React.Dispatch<React.SetStateAction<StatusSignatureType>>;
  statusSignatureValidity: boolean;
  setStatusSignatureValidity: React.Dispatch<React.SetStateAction<boolean>>;
  statusSignatureChecked: boolean;
  setStatusSignatureChecked: React.Dispatch<React.SetStateAction<boolean>>;

  theSociety: TheSocietyType,
  setTheSociety: React.Dispatch<React.SetStateAction<TheSocietyType>>;
  theSocietyValidity: boolean;
  setTheSocietyValidity: React.Dispatch<React.SetStateAction<boolean>>;
  theSocietyChecked: boolean;
  setTheSocietyChecked: React.Dispatch<React.SetStateAction<boolean>>;

  DateTribunal: DateType,
  setDateTribunal: React.Dispatch<React.SetStateAction<DateType>>;

  headOfficeAddress: HeadOfficeAddressType,
  setHeadOfficeAddress: React.Dispatch<React.SetStateAction<HeadOfficeAddressType>>;
  headOfficeAddressValidity: boolean;
  setHeadOfficeAddressValidity: React.Dispatch<React.SetStateAction<boolean>>;
  headOfficeAddressChecked: boolean;
  setHeadOfficeAddressChecked: React.Dispatch<React.SetStateAction<boolean>>;

  individual: IndividualPersonType,
  setIndividual: React.Dispatch<React.SetStateAction<IndividualPersonType>>;
  individualValidity: boolean,
  setIndividualValidity: React.Dispatch<React.SetStateAction<boolean>>;
  individualChecked: boolean,
  setIndividualChecked: React.Dispatch<React.SetStateAction<boolean>>;

  individualNotary: IndividualPersonType,
  setIndividualNotary: React.Dispatch<React.SetStateAction<IndividualPersonType>>;
  individualNotaryValidity: boolean,
  setIndividualNotaryValidity: React.Dispatch<React.SetStateAction<boolean>>;
  individualNotaryChecked: boolean,
  setIndividualNotaryChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // individual With Birth Name
  individualWithBirthName: IndividualWithBirthNameType,
  setIndividualWithBirthName: React.Dispatch<React.SetStateAction<IndividualWithBirthNameType>>;
  individualWithBirthNameValidity: boolean;
  setIndividualWithBirthNameValidity: React.Dispatch<React.SetStateAction<boolean>>;
  individualWithBirthNameChecked: boolean;
  setIndividualWithBirthNameChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // Idividual Person List
  individualPersons: IndividualPersonType[];
  setIndividualPersons: React.Dispatch<React.SetStateAction<IndividualPersonType[]>>;
  individualPersonsValidity: boolean;
  setIndividualPersonsValidity: React.Dispatch<React.SetStateAction<boolean>>;
  individualPersonsChecked: boolean;
  setIndividualPersonsChecked: React.Dispatch<React.SetStateAction<boolean>>;

  individualPersonsHeritier: HeritierType[];
  setIndividualPersonsHeritier: React.Dispatch<React.SetStateAction<HeritierType[]>>;
  individualPersonsValidityHeritier: boolean;
  setIndividualPersonsValidityHeritier: React.Dispatch<React.SetStateAction<boolean>>;
  individualPersonsCheckedHeritier: boolean;
  setIndividualPersonsCheckedHeritier: React.Dispatch<React.SetStateAction<boolean>>;

  // Signing Of The Status 
  signingOfTheStatus: SigningOfTheStatusType;
  setSigningOfTheStatus: React.Dispatch<React.SetStateAction<SigningOfTheStatusType>>;
  signingOfTheStatusValidity: boolean;
  setSigningOfTheStatusValidity: React.Dispatch<React.SetStateAction<boolean>>;
  signingOfTheStatusChecked: boolean;
  setSigningOfTheStatusChecked: React.Dispatch<React.SetStateAction<boolean>>;

  //Tax Service Registration
  taxServiceRegistration: TaxServiceRegistrationType;
  setTaxServiceRegistration: React.Dispatch<React.SetStateAction<TaxServiceRegistrationType>>;
  taxServiceRegistrationValidity: boolean;
  setTaxServiceRegistrationValidity: React.Dispatch<React.SetStateAction<boolean>>;
  taxServiceRegistrationChecked: boolean;
  setTaxServiceRegistrationChecked: React.Dispatch<React.SetStateAction<boolean>>;

  reducedIndividualPerson: ReducedIndividualPersonType,
  setReducedIndividualPerson: React.Dispatch<React.SetStateAction<ReducedIndividualPersonType>>;
  reducedIndividualPersonValidity: boolean,
  setReducedIndividualPersonValidity: React.Dispatch<React.SetStateAction<boolean>>;
  reducedIndividualPersonChecked: boolean,
  setReducedIndividualPersonChecked: React.Dispatch<React.SetStateAction<boolean>>;

  legalEntity: LegalEntityType,
  setLegalEntity: React.Dispatch<React.SetStateAction<LegalEntityType>>;
  legalEntityValidity: boolean,
  setLegalEntityValidity: React.Dispatch<React.SetStateAction<boolean>>;
  legalEntityChecked: boolean,
  setLegalEntityChecked: React.Dispatch<React.SetStateAction<boolean>>;

  reducedLegalEntity: ReducedLegalEntityType,
  setReducedLegalEntity: React.Dispatch<React.SetStateAction<ReducedLegalEntityType>>;
  reducedLegalEntityValidity: boolean,
  setReducedLegalEntityValidity: React.Dispatch<React.SetStateAction<boolean>>;
  reducedLegalEntityChecked: boolean,
  setReducedLegalEntityChecked: React.Dispatch<React.SetStateAction<boolean>>;

  manager: ManagerType;
  setManager: React.Dispatch<React.SetStateAction<ManagerType>>;
  managerValidity: boolean;
  setManagerValidity: React.Dispatch<React.SetStateAction<boolean>>;
  managerChecked: boolean;
  setManagerChecked: React.Dispatch<React.SetStateAction<boolean>>;

  newLastName: string;
  setNewLastName: React.Dispatch<React.SetStateAction<string>>;
  newLastNameValidity: boolean;
  setNewLastNameValidity: React.Dispatch<React.SetStateAction<boolean>>;
  newLastNameChecked: boolean;
  setNewLastNameChecked: React.Dispatch<React.SetStateAction<boolean>>;
  typeNewLastNameData: number;
  setTypeNewLastNameData: React.Dispatch<React.SetStateAction<number>>;

  // ManagerWithQuality
  managerWithQuality: ManagerTypeWithQualite;
  setManagerWithQuality: React.Dispatch<React.SetStateAction<ManagerTypeWithQualite>>;
  managerWithQualityValidity: boolean;
  setManagerWithQualityValidity: React.Dispatch<React.SetStateAction<boolean>>;
  managerWithQualityChecked: boolean;
  setManagerWithQualityChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // new statutory auditor for Departure with replacement of the statutory auditor and alternate (ManagerType)
  newStatutoryAuditor: ManagerType,
  setNewStatutoryAuditor: React.Dispatch<React.SetStateAction<ManagerType>>;
  newStatutoryAuditorValidity: boolean,
  setNewStatutoryAuditorValidity: React.Dispatch<React.SetStateAction<boolean>>;
  newStatutoryAuditorChecked: boolean,
  setNewStatutoryAuditorChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // new reduced statutory auditor for Departure with replacement of the statutory auditor and alternate(ManagerType)
  newAlternateAuditor: ManagerType,
  setNewAlternateAuditor: React.Dispatch<React.SetStateAction<ManagerType>>;
  newAlternateAuditorValidity: boolean,
  setNewAlternateAuditorValidity: React.Dispatch<React.SetStateAction<boolean>>;
  newAlternateAuditorChecked: boolean,
  setNewAlternateAuditorChecked: React.Dispatch<React.SetStateAction<boolean>>;
  typeNewAlternateAuditorData: number,
  setTypeNewAlternateAuditorData: React.Dispatch<React.SetStateAction<number>>;

  // former statutory auditor alternate for Departure with replacement of the statutory auditor and alternate (ReduceManager)
  formerStatutoryAuditor: ReducedManagerType,
  setFormerStatutoryAuditor: React.Dispatch<React.SetStateAction<ReducedManagerType>>;
  formerStatutoryAuditorValidity: boolean,
  setFormerStatutoryAuditorValidity: React.Dispatch<React.SetStateAction<boolean>>;
  formerStatutoryAuditorChecked: boolean,
  setFormerStatutoryAuditorChecked: React.Dispatch<React.SetStateAction<boolean>>;


  // former reduced statutory auditor alternate for Departure with replacement of the statutory auditor and alternate (ReduceManager)
  formerAlternateAuditor: ReducedManagerType,
  setFormerAlternateAuditor: React.Dispatch<React.SetStateAction<ReducedManagerType>>;
  formerAlternateAuditorValidity: boolean,
  setFormerAlternateAuditorValidity: React.Dispatch<React.SetStateAction<boolean>>;
  formerAlternateAuditorChecked: boolean,
  setFormerAlternateAuditorChecked: React.Dispatch<React.SetStateAction<boolean>>;
  typeFormerAlternateAuditorData: number,
  setTypeFormerAlternateAuditorData: React.Dispatch<React.SetStateAction<number>>;

  reducedManager: ReducedManagerType,
  setReducedManager: React.Dispatch<React.SetStateAction<ReducedManagerType>>;
  reducedManagerValidity: boolean;
  setReducedManagerValidity: React.Dispatch<React.SetStateAction<boolean>>;
  reducedManagerChecked: boolean;
  setReducedManagerChecked: React.Dispatch<React.SetStateAction<boolean>>;

  reducedManagers: ReducedManagerType[],
  setReducedManagers: React.Dispatch<React.SetStateAction<ReducedManagerType[]>>;
  reducedManagersValidity: boolean;
  setReducedManagersValidity: React.Dispatch<React.SetStateAction<boolean>>;
  reducedManagersChecked: boolean;
  setReducedManagersChecked: React.Dispatch<React.SetStateAction<boolean>>;

  oldSecondAdministrator: ReducedManagerType,
  setOldSecondAdministrator: React.Dispatch<React.SetStateAction<ReducedManagerType>>;
  oldSecondAdministratorValidity: boolean;
  setOldSecondAdministratorValidity: React.Dispatch<React.SetStateAction<boolean>>;
  oldSecondAdministratorChecked: boolean;
  setOldSecondAdministratorChecked: React.Dispatch<React.SetStateAction<boolean>>;
  typeOldAdministratorData: number,
  setTypeOldAdministratorData: React.Dispatch<React.SetStateAction<number>>;

  managers: ManagerType[];
  setManagers: React.Dispatch<React.SetStateAction<ManagerType[]>>;
  managersValidity: boolean;
  setManagersValidity: React.Dispatch<React.SetStateAction<boolean>>;
  managersChecked: boolean;
  setManagersChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // Affected Individuals List
  affectedIndividuals: AffectedIndividualsType[],
  setAffectedIndividuals: React.Dispatch<React.SetStateAction<AffectedIndividualsType[]>>;
  affectedIndividualsValidity: boolean;
  setAffectedIndividualsValidity: React.Dispatch<React.SetStateAction<boolean>>;
  affectedIndividualsChecked: boolean;
  setAffectedIndividualsChecked: React.Dispatch<React.SetStateAction<boolean>>;
  typeAffectedIndividualsData: number,
  setTypeAffectedIndividualsData: React.Dispatch<React.SetStateAction<number>>;

  liquidators: LiquidatorManagerType[];
  setLiquidators: React.Dispatch<React.SetStateAction<LiquidatorManagerType[]>>;
  liquidatorValidity: boolean;
  setLiquidatorValidity: React.Dispatch<React.SetStateAction<boolean>>;
  liquidatorChecked: boolean;
  setLiquidatorChecked: React.Dispatch<React.SetStateAction<boolean>>;

  associates: ManagerType[],
  setAssociates: React.Dispatch<React.SetStateAction<ManagerType[]>>;
  associatesValidity: boolean;
  setAssociatesValidity: React.Dispatch<React.SetStateAction<boolean>>;
  associatesChecked: boolean;
  setAssociatesChecked: React.Dispatch<React.SetStateAction<boolean>>;

  managersWithRepresentative: ManagerWithRepresentativeType[],
  setManagersWithRepresentative: React.Dispatch<React.SetStateAction<ManagerWithRepresentativeType[]>>;
  managersWithRepresentativeValidity: boolean;
  setManagersWithRepresentativeValidity: React.Dispatch<React.SetStateAction<boolean>>;
  managersWithRepresentativeChecked: boolean;
  setManagersWithRepresentativeChecked: React.Dispatch<React.SetStateAction<boolean>>;

  managersWithRepresentativeList: ManagerWithRepresentativeType[],
  setManagersWithRepresentativeList: React.Dispatch<React.SetStateAction<ManagerWithRepresentativeType[]>>;
  managersWithRepresentativeListValidity: boolean;
  setManagersWithRepresentativeListValidity: React.Dispatch<React.SetStateAction<boolean>>;
  managersWithRepresentativeListChecked: boolean;
  setManagersWithRepresentativeListChecked: React.Dispatch<React.SetStateAction<boolean>>;

  managerWithRepresentative: ManagerWithRepresentativeType,
  setManagerWithRepresentative: React.Dispatch<React.SetStateAction<ManagerWithRepresentativeType>>;
  managerWithRepresentativeValidity: boolean;
  setManagerWithRepresentativeValidity: React.Dispatch<React.SetStateAction<boolean>>;
  managerWithRepresentativeChecked: boolean;
  setManagerWithRepresentativeChecked: React.Dispatch<React.SetStateAction<boolean>>;

  secondManagerWithRepresentative: ManagerWithRepresentativeType,
  setSecondManagerWithRepresentative: React.Dispatch<React.SetStateAction<ManagerWithRepresentativeType>>;
  secondManagerWithRepresentativeValidity: boolean;
  setSecondManagerWithRepresentativeValidity: React.Dispatch<React.SetStateAction<boolean>>;
  secondManagerWithRepresentativeChecked: boolean;
  setSecondManagerWithRepresentativeChecked: React.Dispatch<React.SetStateAction<boolean>>;
  typeSecondManagerWithRepresentativeData: number,
  setTypeSecondManagerWithRepresentativeData: React.Dispatch<React.SetStateAction<number>>;

  statutoryAuditorWithRepresentative: ManagerWithRepresentativeType,
  setStatutoryAuditorWithRepresentative: React.Dispatch<React.SetStateAction<ManagerWithRepresentativeType>>;
  statutoryAuditorWithRepresentativeValidity: boolean,
  setStatutoryAuditorWithRepresentativeValidity: React.Dispatch<React.SetStateAction<boolean>>;
  statutoryAuditorWithRepresentativeChecked: boolean,
  setStatutoryAuditorWithRepresentativeChecked: React.Dispatch<React.SetStateAction<boolean>>;

  deputyAuditorWithRepresentative: ManagerWithRepresentativeType,
  setDeputyAuditorWithRepresentative: React.Dispatch<React.SetStateAction<ManagerWithRepresentativeType>>;
  deputyAuditorWithRepresentativeValidity: boolean,
  setDeputyAuditorWithRepresentativeValidity: React.Dispatch<React.SetStateAction<boolean>>;
  deputyAuditorWithRepresentativeChecked: boolean,
  setDeputyAuditorWithRepresentativeChecked: React.Dispatch<React.SetStateAction<boolean>>;

  councilMeeting: CouncilMeetingType,
  setCouncilMeeting: React.Dispatch<React.SetStateAction<CouncilMeetingType>>;
  councilMeetingValidity: boolean,
  setCouncilMeetingValidity: React.Dispatch<React.SetStateAction<boolean>>;
  councilMeetingChecked: boolean,
  setCouncilMeetingChecked: React.Dispatch<React.SetStateAction<boolean>>;

  identity: IdentityType,
  setIdentity: React.Dispatch<React.SetStateAction<IdentityType>>;
  identityValidity: boolean,
  setIdentityValidity: React.Dispatch<React.SetStateAction<boolean>>;
  identityChecked: boolean,
  setIdentityChecked: React.Dispatch<React.SetStateAction<boolean>>;

  decision: DecisionType,
  setDecision: React.Dispatch<React.SetStateAction<DecisionType>>;
  decisionValidity: boolean,
  setDecisionValidity: React.Dispatch<React.SetStateAction<boolean>>;
  decisionChecked: boolean,
  setDecisionChecked: React.Dispatch<React.SetStateAction<boolean>>;

  decisionWithQuality: DecisionWithQualityType,
  setDecisionWithQuality: React.Dispatch<React.SetStateAction<DecisionWithQualityType>>;
  decisionWithQualityValidity: boolean,
  setDecisionWithQualityValidity: React.Dispatch<React.SetStateAction<boolean>>;
  decisionWithQualityChecked: boolean,
  setDecisionWithQualityChecked: React.Dispatch<React.SetStateAction<boolean>>;

  decisionWithQualityAndEffectiveDate: DecisionWithQualityType,
  setDecisionWithQualityAndEffectiveDate: React.Dispatch<React.SetStateAction<DecisionWithQualityType>>;
  decisionWithQualityAndEffectiveDateValidity: boolean,
  setDecisionWithQualityAndEffectiveDateValidity: React.Dispatch<React.SetStateAction<boolean>>;
  decisionWithQualityAndEffectiveDateChecked: boolean,
  setDecisionWithQualityAndEffectiveDateChecked: React.Dispatch<React.SetStateAction<boolean>>;

  decisionWithEffectiveDate: DecisionType,
  setDecisionWithEffectiveDate: React.Dispatch<React.SetStateAction<DecisionType>>;
  decisionWithEffectiveDateValidity: boolean,
  setDecisionWithEffectiveDateValidity: React.Dispatch<React.SetStateAction<boolean>>;
  decisionWithEffectiveDateChecked: boolean,
  setDecisionWithEffectiveDateChecked: React.Dispatch<React.SetStateAction<boolean>>;

  DurationDateDébut: DurationManagementType,
  setDurationDateDébut: React.Dispatch<React.SetStateAction<DurationManagementType>>;
  durationDateDébutValidity: boolean,
  setdurationDateDébutValidity: React.Dispatch<React.SetStateAction<boolean>>;
  durationDateDébutChecked: boolean,
  setDurationDateDébutChecked: React.Dispatch<React.SetStateAction<boolean>>;

  address: AddressType,
  setAddress: React.Dispatch<React.SetStateAction<AddressType>>;
  addressValidity: boolean,
  setAddressValidity: React.Dispatch<React.SetStateAction<boolean>>;
  addressChecked: boolean,
  setAddressChecked: React.Dispatch<React.SetStateAction<boolean>>;

  addressedeces: DateTypeDeces,
  setAddressdeces: React.Dispatch<React.SetStateAction<DateTypeDeces>>;



  // Location of oppositions for the same registry
  locationOppositionsRegistry: AddressType,
  setLocationOppositionsRegistry: React.Dispatch<React.SetStateAction<AddressType>>;
  locationOppositionsRegistryValidity: boolean,
  setLocationOppositionsRegistryValidity: React.Dispatch<React.SetStateAction<boolean>>;
  locationOppositionsRegistryChecked: boolean,
  setLocationOppositionsRegistryChecked: React.Dispatch<React.SetStateAction<boolean>>;

  //Location of oppositions for validity
  validityOppositionLocation: AddressType,
  setValidityOppositionLocation: React.Dispatch<React.SetStateAction<AddressType>>;
  validityOppositionLocationValidity: boolean,
  setValidityOppositionLocationValidity: React.Dispatch<React.SetStateAction<boolean>>;
  validityOppositionLocationChecked: boolean,
  setValidityOppositionLocationChecked: React.Dispatch<React.SetStateAction<boolean>>;

  date: DateType,
  setDate: React.Dispatch<React.SetStateAction<DateType>>;
  dateValidity: boolean,
  setDateValidity: React.Dispatch<React.SetStateAction<boolean>>;
  dateChecked: boolean,
  setDateChecked: React.Dispatch<React.SetStateAction<boolean>>;
  dateofficiant: LegalEntityTypeOfficiant,
  setDateofficiant: React.Dispatch<React.SetStateAction<LegalEntityTypeOfficiant>>;

  dateNotary: DateType,
  setdateNotary: React.Dispatch<React.SetStateAction<DateType>>;
  dateValidityNotary: boolean,
  setdateValidityNotary: React.Dispatch<React.SetStateAction<boolean>>;
  dateCheckedNotary: boolean,
  setdateCheckedNotary: React.Dispatch<React.SetStateAction<boolean>>;

  datedeces: DateType,
  setdatedeces: React.Dispatch<React.SetStateAction<DateType>>;
  datecheckedDeces: boolean,
  setdatecheckedDeces: React.Dispatch<React.SetStateAction<boolean>>;
  dateValidityDeces: boolean,
  setDateValidityDeces: React.Dispatch<React.SetStateAction<boolean>>;


  personneeDecede: LegalEntityType,
  setpersonneeDecede: React.Dispatch<React.SetStateAction<LegalEntityType>>;
  personneeDecedechecked: boolean,
  setpersonneeDecedechecked: React.Dispatch<React.SetStateAction<boolean>>;
  personneeDecedeValidity: boolean,
  setpersonneeDecedeValidity: React.Dispatch<React.SetStateAction<boolean>>;



  checkedofficiant: boolean,
  setcheckedofficiant: React.Dispatch<React.SetStateAction<boolean>>;
  officiantValidity: boolean,
  setofficiantValidity: React.Dispatch<React.SetStateAction<boolean>>;

  tribunalValidity: boolean,
  settribunalValidity: React.Dispatch<React.SetStateAction<boolean>>;

  heritierValidity: boolean,
  setheritierValidity: React.Dispatch<React.SetStateAction<boolean>>;

  checkedtribunal: boolean,
  setcheckedtribunal: React.Dispatch<React.SetStateAction<boolean>>;

  checkedHeritier: boolean,
  setcheckedHeritier: React.Dispatch<React.SetStateAction<boolean>>;


  datesignature: DateTypesignature,
  setDatesignature: React.Dispatch<React.SetStateAction<DateTypesignature>>;
  dateValiditysignature: boolean,
  setDateValiditysignature: React.Dispatch<React.SetStateAction<boolean>>;
  dateCheckedsignature: boolean,
  setDateCheckedsignature: React.Dispatch<React.SetStateAction<boolean>>;

  // Date of receipt
  dateOfReceipt: DateType,
  setDateOfReceipt: React.Dispatch<React.SetStateAction<DateType>>;
  dateOfReceiptValidity: boolean,
  setDateOfReceiptValidity: React.Dispatch<React.SetStateAction<boolean>>;
  dateOfReceiptChecked: boolean,
  setDateOfReceiptChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // Date of filing
  dateOfFiling: DateType,
  setDateOfFiling: React.Dispatch<React.SetStateAction<DateType>>;
  dateOfFilingValidity: boolean,
  setDateOfFilingValidity: React.Dispatch<React.SetStateAction<boolean>>;
  dateOfFilingChecked: boolean,
  setDateOfFilingChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // Date of will
  dateOfWill: DateType,
  setDateOfWill: React.Dispatch<React.SetStateAction<DateType>>;
  dateOfWillValidity: boolean,
  setDateOfWillValidity: React.Dispatch<React.SetStateAction<boolean>>;
  dateOfWillChecked: boolean,
  setDateOfWillChecked: React.Dispatch<React.SetStateAction<boolean>>;

  dateOfBirth: DateOfBirthAndCityType,
  setDateOfBirth: React.Dispatch<React.SetStateAction<DateOfBirthAndCityType>>;
  dateOfBirthValidity: boolean,
  setDateOfBirthValidity: React.Dispatch<React.SetStateAction<boolean>>;
  dateOfBirthChecked: boolean,
  setDateOfBirthChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // Date Registration Information 
  registrationDate: DateType,
  setRegistrationDate: React.Dispatch<React.SetStateAction<DateType>>;
  registrationDateValidity: boolean,
  setRegistrationDateValidity: React.Dispatch<React.SetStateAction<boolean>>;
  registrationDateChecked: boolean,
  setRegistrationDateChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // Old Capital Change
  oldCapitalChange: CapitalType,
  setOldCapitalChange: React.Dispatch<React.SetStateAction<CapitalType>>;
  oldCapitalChangeValidity: boolean,
  setOldCapitalChangeValidity: React.Dispatch<React.SetStateAction<boolean>>;
  oldCapitalChangeChecked: boolean,
  setOldCapitalChangeChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // New Capital Change
  newCapitalChange: CapitalType,
  setNewCapitalChange: React.Dispatch<React.SetStateAction<CapitalType>>;
  newCapitalChangeValidity: boolean,
  setNewCapitalChangeValidity: React.Dispatch<React.SetStateAction<boolean>>;
  newCapitalChangeChecked: boolean,
  setNewCapitalChangeChecked: React.Dispatch<React.SetStateAction<boolean>>;

  auditorsChange: number,
  setAuditorsChange: React.Dispatch<React.SetStateAction<number>>;

  notaryData: number,
  setNotaryData: React.Dispatch<React.SetStateAction<number>>;

  // Transformation of society
  typeTransformationOfSociety: string,
  setTypeTransformationOfSociety: React.Dispatch<React.SetStateAction<string>>;

  // Transformation of society SARL
  typeTransformationOfSocietySARL: string,
  setTypeTransformationOfSocietySARL: React.Dispatch<React.SetStateAction<string>>;


  // Date With Effectiv Date
  dateWhithEffectiveDate: DateType,
  setDateWhithEffectiveDate: React.Dispatch<React.SetStateAction<DateType>>;
  dateWhithEffectiveDateValidity: boolean,
  setDateWhithEffectiveDateValidity: React.Dispatch<React.SetStateAction<boolean>>;
  dateWhithEffectiveDateChecked: boolean,
  setDateWhithEffectiveDateChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // Change Of Capital
  changeCapital: CapitalType,
  setChangeCapital: React.Dispatch<React.SetStateAction<CapitalType>>;
  changeCapitalValidity: boolean,
  setChangeCapitalValidity: React.Dispatch<React.SetStateAction<boolean>>;
  changeCapitalChecked: boolean,
  setChangeCapitalChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // Capital Input
  transfertAmount: CapitalType,
  setTransfertAmount: React.Dispatch<React.SetStateAction<CapitalType>>;
  transfertAmountValidity: boolean,
  setTransfertAmountValidity: React.Dispatch<React.SetStateAction<boolean>>;
  transfertAmountChecked: boolean,
  setTransfertAmountChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // Managing Director List
  generalManagers: ManagerType[];
  setGeneralManagers: React.Dispatch<React.SetStateAction<ManagerType[]>>;
  generalManagersValidity: boolean,
  setGeneralManagersValidity: React.Dispatch<React.SetStateAction<boolean>>;
  generalManagersChecked: boolean,
  setGeneralManagersChecked: React.Dispatch<React.SetStateAction<boolean>>;
  typeGeneralManagersData: number,
  setTypeGeneralManagersData: React.Dispatch<React.SetStateAction<number>>;

  // Managing List with qualities réduit
  reducedGeneralManagersWithQualite: ReducedManagerTypeWithQuality[];
  setReducedGeneralManagersWithQualite: React.Dispatch<React.SetStateAction<ReducedManagerTypeWithQuality[]>>;
  reducedGeneralManagersWithQualiteValidity: boolean,
  setReducedGeneralManagersWithQualiteValidity: React.Dispatch<React.SetStateAction<boolean>>;
  reducedGeneralManagersWithQualiteChecked: boolean,
  setReducedGeneralManagersWithQualiteChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // Managing List with qualities
  generalManagersWithQualite: ManagerTypeWithQualite[];
  setGeneralManagersWithQualite: React.Dispatch<React.SetStateAction<ManagerTypeWithQualite[]>>;


  generalManagersWithQualiteValidity: boolean,
  setGeneralManagersWithQualiteValidity: React.Dispatch<React.SetStateAction<boolean>>;
  generalManagersWithQualiteChecked: boolean,
  setGeneralManagersWithQualiteChecked: React.Dispatch<React.SetStateAction<boolean>>;
  typeGeneralManagersWithQualiteData: number,
  setTypeGeneralManagersWithQualiteData: React.Dispatch<React.SetStateAction<number>>;


  // executiveOfficers
  executiveOfficers: ManagerType[];
  setExecutiveOfficers: React.Dispatch<React.SetStateAction<ManagerType[]>>;
  executiveOfficersValidity: boolean;
  setExecutiveOfficersValidity: React.Dispatch<React.SetStateAction<boolean>>;
  executiveOfficersChecked: boolean,
  setExecutiveOfficersChecked: React.Dispatch<React.SetStateAction<boolean>>;
  typeExecutiveOfficersData: number;
  setTypeExecutiveOfficersData: React.Dispatch<React.SetStateAction<number>>;

  // statutoryAuditor
  statutoryAuditor: ManagerType;
  setStatutoryAuditor: React.Dispatch<React.SetStateAction<ManagerType>>;
  statutoryAuditorValidity: boolean;
  setStatutoryAuditorValidity: React.Dispatch<React.SetStateAction<boolean>>;
  statutoryAuditorChecked: boolean;
  setStatutoryAuditorChecked: React.Dispatch<React.SetStateAction<boolean>>;
  typeStatutoryAuditorData: number
  setTypeStatutoryAuditorData: React.Dispatch<React.SetStateAction<number>>;

  // AlternateAuditor
  alternateAuditor: ManagerType;
  setAlternateAuditor: React.Dispatch<React.SetStateAction<ManagerType>>;
  alternateAuditorValidity: boolean;
  setAlternateAuditorValidity: React.Dispatch<React.SetStateAction<boolean>>;
  alternateAuditorChecked: boolean;
  setAlternateAuditorChecked: React.Dispatch<React.SetStateAction<boolean>>;
  typeAlternateAuditorData: number
  setTypeAlternateAuditorData: React.Dispatch<React.SetStateAction<number>>;

  absorbedCompany: LegalEntityType;
  setAbsorbedCompany: React.Dispatch<React.SetStateAction<LegalEntityType>>;
  absorbedCompanyChecked: boolean;
  setAbsorbedCompanyChecked: React.Dispatch<React.SetStateAction<boolean>>;
  absorbedCompanyValidity: boolean;
  setAbsorbedCompanyValidity: React.Dispatch<React.SetStateAction<boolean>>;

  absorbingCompany: LegalEntityType;
  setAbsorbingCompany: React.Dispatch<React.SetStateAction<LegalEntityType>>;
  absorbingCompanyChecked: boolean;
  setAbsorbingCompanyChecked: React.Dispatch<React.SetStateAction<boolean>>;
  absorbingCompanyValidity: boolean;
  setAbsorbingCompanyValidity: React.Dispatch<React.SetStateAction<boolean>>;

  leaderChange: LeaderChangeType;
  setLeaderChange: React.Dispatch<React.SetStateAction<LeaderChangeType>>
  leaderChangeValidity: boolean;
  setLeaderChangeValidity: React.Dispatch<React.SetStateAction<boolean>>
  leaderChangeChecked: boolean;
  setLeaderChangeChecked: React.Dispatch<React.SetStateAction<boolean>>

  partnerChange: PartnerChangeType;
  setPartnerChange: React.Dispatch<React.SetStateAction<PartnerChangeType>>
  partnerChangeValidity: boolean;
  setPartnerChangeValidity: React.Dispatch<React.SetStateAction<boolean>>
  partnerChangeChecked: boolean;
  setPartnerChangeChecked: React.Dispatch<React.SetStateAction<boolean>>

  typeGeneralManagerData: number
  setTypeGeneralManagerData: React.Dispatch<React.SetStateAction<number>>

  typeAddress: number
  setTypeAddress: React.Dispatch<React.SetStateAction<number>>

  typeHeirsData: number
  setTypeHeirsData: React.Dispatch<React.SetStateAction<number>>
  
  liquidationHeadquarter: string
  setLiquidationHeadquarter: React.Dispatch<React.SetStateAction<string>>

  admission: admissionToMeetingType,
  setAdmission: React.Dispatch<React.SetStateAction<admissionToMeetingType>>;

  clause: Clause,
  setClause: React.Dispatch<React.SetStateAction<Clause>>;

  inputGeneralDirector: number,
  setInputGeneralDirector: React.Dispatch<React.SetStateAction<number>>;

  admissionDescriptionText: DescriptionTextType,
  setAdmissionDescriptionText: React.Dispatch<React.SetStateAction<DescriptionTextType>>
  admissionDescriptionTextValidity: boolean,
  setAdmissionDescriptionTextValidity: React.Dispatch<React.SetStateAction<boolean>>
  admissionDescriptionTextChecked: boolean,
  setAdmissionDescriptionTextChecked: React.Dispatch<React.SetStateAction<boolean>>

  clauseDescriptionText: DescriptionTextType,
  setClauseDescriptionText: React.Dispatch<React.SetStateAction<DescriptionTextType>>
  clauseDescriptionTextValidity: boolean,
  setClauseDescriptionTextValidity: React.Dispatch<React.SetStateAction<boolean>>
  clauseDescriptionTextChecked: boolean,
  setClauseDescriptionTextChecked: React.Dispatch<React.SetStateAction<boolean>>

  changeSocialObject: ChangeSocialObjectType,
  setChangeSocialObject: React.Dispatch<React.SetStateAction<ChangeSocialObjectType>>;
  changeSocialObjectValidity: boolean;
  setChangeSocialObjectValidity: React.Dispatch<React.SetStateAction<boolean>>;
  changeSocialObjectChecked: boolean;
  setChangeSocialObjectChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // Type Registration Data
  typeRegistrationData: 'bordereau' | 'dossier';
  setTypeRegistrationData: React.Dispatch<React.SetStateAction<'bordereau' | 'dossier'>>;

  typeOppositionData: number,
  setTypeOppositionData: React.Dispatch<React.SetStateAction<number>>;

  // MULTIPLE CHANGES
  // manager and presidency change
  managerAndPresidencyChange: number,
  setManagerAndPresidencyChange: React.Dispatch<React.SetStateAction<number>>;

  // Denomination change
  companyNameChange: number,
  setCompanyNameChange: React.Dispatch<React.SetStateAction<number>>;

  // Social object change
  socialObjectChange: number,
  setSocialObjectChange: React.Dispatch<React.SetStateAction<number>>;

  // Social capital change
  socialCapitalChange: number,
  setSocialCapitalChange: React.Dispatch<React.SetStateAction<number>>;

  // Duration change
  durationChange: number,
  setDurationChange: React.Dispatch<React.SetStateAction<number>>;

  // Auditor change
  auditorChange: number,
  setAuditorChange: React.Dispatch<React.SetStateAction<number>>;

  // Family Situation
  typeFamilySituationData: number,
  setTypeFamilySituationData: React.Dispatch<React.SetStateAction<number>>;

  // Seat transfert change
  seatTransfertChange: number,
  setSeatTransfertChange: React.Dispatch<React.SetStateAction<number>>;

  // manager and presidency change effective date
  presidencyChangeEffectiveDate: DateType,
  setPresidencyChangeEffectiveDate: React.Dispatch<React.SetStateAction<DateType>>;
  presidencyChangeEffectiveDateValidity: boolean,
  setPresidencyChangeEffectiveDateValidity: React.Dispatch<React.SetStateAction<boolean>>;
  presidencyChangeEffectiveDateChecked: boolean,
  setPresidencyChangeEffectiveDateChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // company name change effective date
  companyNameChangeEffectiveDate: DateType,
  setCompanyNameChangeEffectiveDate: React.Dispatch<React.SetStateAction<DateType>>;
  companyNameChangeEffectiveDateValidity: boolean,
  setCompanyNameChangeEffectiveDateValidity: React.Dispatch<React.SetStateAction<boolean>>;
  companyNameChangeEffectiveDateChecked: boolean,
  setCompanyNameChangeEffectiveDateChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // social object change effective date
  socialObjectChangeEffectiveDate: DateType,
  setSocialObjectChangeEffectiveDate: React.Dispatch<React.SetStateAction<DateType>>;
  socialObjectChangeEffectiveDateValidity: boolean,
  setSocialObjectChangeEffectiveDateValidity: React.Dispatch<React.SetStateAction<boolean>>;
  socialObjectChangeEffectiveDateChecked: boolean,
  setSocialObjectChangeEffectiveDateChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // social capital change effective date
  socialCapitalChangeEffectiveDate: DateType,
  setSocialCapitalChangeEffectiveDate: React.Dispatch<React.SetStateAction<DateType>>;
  socialCapitalChangeEffectiveDateValidity: boolean,
  setSocialCapitalChangeEffectiveDateValidity: React.Dispatch<React.SetStateAction<boolean>>;
  socialCapitalChangeEffectiveDateChecked: boolean,
  setSocialCapitalChangeEffectiveDateChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // duration change effective date
  durationChangeEffectiveDate: DateType,
  setDurationChangeEffectiveDate: React.Dispatch<React.SetStateAction<DateType>>;
  durationChangeEffectiveDateValidity: boolean,
  setDurationChangeEffectiveDateValidity: React.Dispatch<React.SetStateAction<boolean>>;
  durationChangeEffectiveDateChecked: boolean,
  setDurationChangeEffectiveDateChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // duration change date
  durationChangeDate: DateType,
  setDurationChangeDate: React.Dispatch<React.SetStateAction<DateType>>;
  durationChangeDateValidity: boolean,
  setDurationChangeDateValidity: React.Dispatch<React.SetStateAction<boolean>>;
  durationChangeDateChecked: boolean,
  setDurationChangeDateChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // auditor change effective date
  auditorChangeEffectiveDate: DateType,
  setAuditorChangeEffectiveDate: React.Dispatch<React.SetStateAction<DateType>>;
  auditorChangeEffectiveDateValidity: boolean,
  setAuditorChangeEffectiveDateValidity: React.Dispatch<React.SetStateAction<boolean>>;
  auditorChangeEffectiveDateChecked: boolean,
  setAuditorChangeEffectiveDateChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // seat transfert change effective date
  seatTransfertChangeEffectiveDate: DateType,
  setseatTransfertChangeEffectiveDate: React.Dispatch<React.SetStateAction<DateType>>;
  seatTransfertChangeEffectiveDateValidity: boolean,
  setseatTransfertChangeEffectiveDateValidity: React.Dispatch<React.SetStateAction<boolean>>;
  seatTransfertChangeEffectiveDateChecked: boolean,
  setseatTransfertChangeEffectiveDateChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // reduced statutoryAuditor
  reducedStatutoryAuditor: ReducedManagerType;
  setReducedStatutoryAuditor: React.Dispatch<React.SetStateAction<ReducedManagerType>>;
  reducedStatutoryAuditorValidity: boolean;
  setReducedStatutoryAuditorValidity: React.Dispatch<React.SetStateAction<boolean>>;
  reducedStatutoryAuditorChecked: boolean;
  setReducedStatutoryAuditorChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // cédant
  sellerManager: ManagerType;
  setSellerManager: React.Dispatch<React.SetStateAction<ManagerType>>;
  sellerManagerValidity: boolean;
  setSellerManagerValidity: React.Dispatch<React.SetStateAction<boolean>>;
  sellerManagerChecked: boolean;
  setSellerManagerChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // acquéreur
  buyerManager: ManagerType;
  setBuyerManager: React.Dispatch<React.SetStateAction<ManagerType>>;
  buyerManagerValidity: boolean;
  setBuyerManagerValidity: React.Dispatch<React.SetStateAction<boolean>>;
  buyerManagerChecked: boolean;
  setBuyerManagerChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // activité du fonds
  fundActivity: TextareaType;
  setFundActivity: React.Dispatch<React.SetStateAction<TextareaType>>;
  fundActivityValidity: boolean;
  setFundActivityValidity: React.Dispatch<React.SetStateAction<boolean>>;
  fundActivityChecked: boolean;
  setFundActivityChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // actéléments du fonds
  fundElements: TextareaType;
  setFundElements: React.Dispatch<React.SetStateAction<TextareaType>>;
  fundElementsValidity: boolean;
  setFundElementsValidity: React.Dispatch<React.SetStateAction<boolean>>;
  fundElementsChecked: boolean;
  setFundElementsChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // Death Related Info
  deathRelatedInfo: DeathRelatedInfoType;
  setDeathRelatedInfo: React.Dispatch<React.SetStateAction<DeathRelatedInfoType>>;
  deathRelatedInfoValidity: boolean;
  setDeathRelatedInfoValidity: React.Dispatch<React.SetStateAction<boolean>>;
  deathRelatedInfoChecked: boolean;
  setDeathRelatedInfoChecked: React.Dispatch<React.SetStateAction<boolean>>;

  // New Name
  fullName: NewNameType;
  setFullName: React.Dispatch<React.SetStateAction<NewNameType>>;

  // déclaration d'insaisissabilité

  registrationReference: RegistrationReferenceType;
  setRegistrationReference: React.Dispatch<React.SetStateAction<RegistrationReferenceType>>;
  registrationReferenceValidity: boolean;
  setRegistrationReferenceValidity: React.Dispatch<React.SetStateAction<boolean>>;
  registrationReferenceChecked: boolean;
  setRegistrationReferenceChecked: React.Dispatch<React.SetStateAction<boolean>>;

  notaryContact: NotaryContactType;
  setNotaryContact: React.Dispatch<React.SetStateAction<NotaryContactType>>;
  notaryContactValidity: boolean;
  setNotaryContactValidity: React.Dispatch<React.SetStateAction<boolean>>;
  notaryContactChecked: boolean;
  setNotaryContactChecked: React.Dispatch<React.SetStateAction<boolean>>;

  applicant: IndividualWithFamilySituationType;
  setApplicant: React.Dispatch<React.SetStateAction<IndividualWithFamilySituationType>>;
  applicantValidity: boolean;
  setApplicantValidity: React.Dispatch<React.SetStateAction<boolean>>;
  applicantChecked: boolean;
  setApplicantChecked: React.Dispatch<React.SetStateAction<boolean>>;
  
  mariageContract: MariageContractType;
  setMariageContract: React.Dispatch<React.SetStateAction<MariageContractType>>;

  residentialAddress: AddressType;
  setResidentialAddress: React.Dispatch<React.SetStateAction<AddressType>>;
  residentialAddressValidity: boolean;
  setResidentialAddressValidity: React.Dispatch<React.SetStateAction<boolean>>;
  residentialAddressChecked: boolean;
  setResidentialAddressChecked: React.Dispatch<React.SetStateAction<boolean>>;

  mainResidenceAddress: AddressType;
  setMainResidenceAddress: React.Dispatch<React.SetStateAction<AddressType>>;
  mainResidenceAddressValidity: boolean;
  setMainResidenceAddressValidity: React.Dispatch<React.SetStateAction<boolean>>;
  mainResidenceAddressChecked: boolean;
  setMainResidenceAddressChecked: React.Dispatch<React.SetStateAction<boolean>>;
  
  deathDate: DateType;
  setDeathDate: React.Dispatch<React.SetStateAction<DateType>>;

  // changement de régime matrimonial
  
  spouseNumberOne: IndividualWithProfessionType;
  setSpouseNumberOne: React.Dispatch<React.SetStateAction<IndividualWithProfessionType>>;
  spouseNumberOneValidity: boolean;
  setSpouseNumberOneValidity: React.Dispatch<React.SetStateAction<boolean>>;
  spouseNumberOneChecked: boolean;
  setSpouseNumberOneChecked: React.Dispatch<React.SetStateAction<boolean>>;

  spouseOneBirth: DateOfBirthAndCityType;
  setSpouseOneBirth: React.Dispatch<React.SetStateAction<DateOfBirthAndCityType>>;
  spouseOneBirthValidity: boolean;
  setSpouseOneBirthValidity: React.Dispatch<React.SetStateAction<boolean>>;
  spouseOneBirthChecked: boolean;
  setSpouseOneBirthChecked: React.Dispatch<React.SetStateAction<boolean>>;
  
  spouseNumberTwo: IndividualWithProfessionType;
  setSpouseNumberTwo: React.Dispatch<React.SetStateAction<IndividualWithProfessionType>>;
  spouseNumberTwoValidity: boolean;
  setSpouseNumberTwoValidity: React.Dispatch<React.SetStateAction<boolean>>;
  spouseNumberTwoChecked: boolean;
  setSpouseNumberTwoChecked: React.Dispatch<React.SetStateAction<boolean>>;

  spouseTwoBirth: DateOfBirthAndCityType;
  setSpouseTwoBirth: React.Dispatch<React.SetStateAction<DateOfBirthAndCityType>>;
  spouseTwoBirthValidity: boolean;
  setSpouseTwoBirthValidity: React.Dispatch<React.SetStateAction<boolean>>;
  spouseTwoBirthChecked: boolean;
  setSpouseTwoBirthChecked: React.Dispatch<React.SetStateAction<boolean>>;

  spousesAddress: HeadOfficeAddressType;
  setSpousesAddress: React.Dispatch<React.SetStateAction<HeadOfficeAddressType>>;
  spousesAddressValidity: boolean;
  setSpousesAddressValidity: React.Dispatch<React.SetStateAction<boolean>>;
  spousesAddressChecked: boolean;
  setSpousesAddressChecked: React.Dispatch<React.SetStateAction<boolean>>;

  previousRegime: PreviousMaritalRegimeType;
  setPreviousRegime: React.Dispatch<React.SetStateAction<PreviousMaritalRegimeType>>;
  previousRegimeValidity: boolean;
  setPreviousRegimeValidity: React.Dispatch<React.SetStateAction<boolean>>;
  previousRegimeChecked: boolean;
  setPreviousRegimeChecked: React.Dispatch<React.SetStateAction<boolean>>;

  newRegime: string;
  setNewRegime: React.Dispatch<React.SetStateAction<string>>;

  contractDate: DateType;
  setcontractDate: React.Dispatch<React.SetStateAction<DateType>>;

  typeNotaryData: number;
  setTypeNotaryData: React.Dispatch<React.SetStateAction<number>>;

  officiatingNotary: IndividualPersonType;
  setOfficiatingNotary: React.Dispatch<React.SetStateAction<IndividualPersonType>>;
  officiatingNotaryValidity: boolean;
  setOfficiatingNotaryValidity: React.Dispatch<React.SetStateAction<boolean>>;
  officiatingNotaryChecked: boolean;
  setOfficiatingNotaryChecked: React.Dispatch<React.SetStateAction<boolean>>;
  
  oppositionsNotary: IndividualPersonType;
  setOppositionsNotary: React.Dispatch<React.SetStateAction<IndividualPersonType>>;
  oppositionsNotaryValidity: boolean;
  setOppositionsNotaryValidity: React.Dispatch<React.SetStateAction<boolean>>;
  oppositionsNotaryChecked: boolean;
  setOppositionsNotaryChecked: React.Dispatch<React.SetStateAction<boolean>>;

  
  // Draft libre
  denomination: string;
  setDenomination: React.Dispatch<React.SetStateAction<string>>;

  legalForm: string;
  setLegalForm: React.Dispatch<React.SetStateAction<string>>;
  
  clientReference: string;
  setClientReference: React.Dispatch<React.SetStateAction<string>>;
  
  texteAnnonce: string;
  setTexteAnnonce: React.Dispatch<React.SetStateAction<string>>;
  

  logos: LogoType[];
  setLogos: React.Dispatch<React.SetStateAction<LogoType[]>>;

  // User Information
  userName: string;
  setUserName: React.Dispatch<React.SetStateAction<string>>;
  userFirstname: string;
  setUserFirstname: React.Dispatch<React.SetStateAction<string>>;

// announcement logoID and header
  entete: string;
  setEntete: React.Dispatch<React.SetStateAction<string>>;
  floid: string;
  setFloid: React.Dispatch<React.SetStateAction<string>>;
  logoLibelle: string;
  setLogoLibelle: React.Dispatch<React.SetStateAction<string>>;
  choix: string;
  setChoix: React.Dispatch<React.SetStateAction<string>>;

  status:string;
  setUserStatus: React.Dispatch<React.SetStateAction<string>>;

  pointsToUse: number;
  setPointsToUse: React.Dispatch<React.SetStateAction<number>>;

  userPoints: number;
  setUserPoints: React.Dispatch<React.SetStateAction<number>>;


  profilePicture:string|null
  setProfilePicture: React.Dispatch<React.SetStateAction<string | null>>;
  
  clearContext: () => void;
}

// Créer le context avec une valeur par défaut
export const AppContext = createContext<AppContextType | undefined>(undefined);

// Créer un fournisseur (Provider) du context
interface AppProviderProps {
  children: ReactNode;
}

export const AppContextProvider: React.FC<AppProviderProps> = ({ children }) => {

  const [ authenticatedUser, setAuthenticatedUser ] = useState<UserModel | null>(null)

  const [ currentAnnonceId, setCurrentAnnonceId ] = useState < number | null > ( null )

  //userAnnonces
  const [userAnnonces, setUserAnnonces] = useState <Annonce[]> ([])

  // autoDiscount
  const [autoDiscount, setAutoDiscount] = useState <number> (0)

  // Discount Id
  const [discountId, setDiscountId] = useState <number | null> ( null )

  // Discount
  const [discountAmount, setDiscountAmount] = useState <number> (0)

  // draft
  const [lastTab, setLastTab] = useState <string> ('')
  const [draftFormData, setDraftFormData] = useState <string> ('')
  
  // support de presse
  const [ pressSupportPostalCode, setPressSupportPostalCode ] = useState <string> ('')
  const [ pressSupportCity, setPressSupportCity ] = useState <string> ('')
  
  // additive / corrective announcement
  const [ currentAnnoucement, setCurrentAnnoucement ] = useState<Annonce | null>( null );
  const [ announcementTypeList, setAnnouncementTypeList ] = useState <TabStypeItem[]> ([]);
  
  const [selectedType, setSelectedType] = useState<TabStypeItem | null>(null);
  
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [checkedIndex, setCheckedIndex] = useState<number>(1);

  //Registration Notices
  const [registrationNotices, setRegistrationNotices] = useState<RegistrationNoticesType>(initialRegistrationNoticesState)
  const [registrationNoticesValidity, setRegistrationNoticesValidity] = useState<boolean>(false)
  const [registrationNoticesChecked, setRegistrationNoticesChecked] = useState<boolean>(false)

  const [individual, setIndividual] = useState<IndividualPersonType>(initialIndividualState)
  const [individualValidity, setIndividualValidity] = useState<boolean>(false)
  const [individualChecked, setIndividualChecked] = useState<boolean>(false)

  const [ individualNotary, setIndividualNotary ] = useState<IndividualPersonType>( initialIndividualState )
  const [ individualNotaryValidity, setIndividualNotaryValidity ] = useState<boolean>( false )
  const [ individualNotaryChecked, setIndividualNotaryChecked ] = useState<boolean>( false )

  // individual With Birth Name
  const [individualWithBirthName, setIndividualWithBirthName] = useState<IndividualWithBirthNameType>(initialIndividualWithBirthNameState)
  const [individualWithBirthNameValidity, setIndividualWithBirthNameValidity] = useState<boolean>(false)
  const [individualWithBirthNameChecked, setIndividualWithBirthNameChecked] = useState<boolean>(false)

  // Individual Person List
  const [individualPersons, setIndividualPersons] = useState<IndividualPersonType[]>([initialIndividualState])
  const [individualPersonsValidity, setIndividualPersonsValidity] = useState<boolean>(false)
  const [individualPersonsChecked, setIndividualPersonsChecked] = useState<boolean>(false)

  const [ reducedIndividualPerson, setReducedIndividualPerson ] = useState<ReducedIndividualPersonType>( initialReducedIndividualState )
  const [ reducedIndividualPersonValidity, setReducedIndividualPersonValidity ] = useState<boolean>( false )
  const [ reducedIndividualPersonChecked, setReducedIndividualPersonChecked ] = useState<boolean>( false )

  const [individualPersonsHeritier, setIndividualPersonsHeritier] = useState<HeritierType[]>([heritierIndividualState])
  const [individualPersonsValidityHeritier, setIndividualPersonsValidityHeritier] = useState<boolean>(false)
  const [individualPersonsCheckedHeritier, setIndividualPersonsCheckedHeritier] = useState<boolean>(false)

  // const [reducedIndividualPerson, setReducedIndividualPerson] = useState<ReducedIndividualPersonType>(initialReducedIndividualState)
  // const [reducedIndividualPersonValidity, setReducedIndividualPersonValidity] = useState<boolean>(false)
  // const [reducedIndividualPersonChecked, setReducedIndividualPersonChecked] = useState<boolean>(false)

  const [legalEntity, setLegalEntity] = useState<LegalEntityType>(initialLegalEntityState);
  const [personneeDecede, setpersonneeDecede] = useState<LegalEntityType>(initialLegalEntityState);
  const [legalEntityValidity, setLegalEntityValidity] = useState<boolean>(false);
  const [legalEntityChecked, setLegalEntityChecked] = useState<boolean>(false);

  const [reducedLegalEntity, setReducedLegalEntity] = useState<ReducedLegalEntityType>(initialReducedLegalEntityState)
  const [reducedLegalEntityValidity, setReducedLegalEntityValidity] = useState<boolean>(false)
  const [reducedLegalEntityChecked, setReducedLegalEntityChecked] = useState<boolean>(false)

  const [manager, setManager] = useState<ManagerType>(initialManagerState)
  const [managerValidity, setManagerValidity] = useState<boolean>(false)
  const [managerChecked, setManagerChecked] = useState<boolean>(false)

  // New Last Name
  const [newLastName, setNewLastName] = useState<string>('')
  const [newLastNameValidity, setNewLastNameValidity] = useState<boolean>(false)
  const [newLastNameChecked, setNewLastNameChecked] = useState<boolean>(false)
  const [typeNewLastNameData, setTypeNewLastNameData] = useState<number>(0)

  // Signing Of The Status Schema
  const [signingOfTheStatus, setSigningOfTheStatus] = useState<SigningOfTheStatusType>(initialSigningOfTheStatusState)
  const [signingOfTheStatusValidity, setSigningOfTheStatusValidity] = useState<boolean>(false)
  const [signingOfTheStatusChecked, setSigningOfTheStatusChecked] = useState<boolean>(false)

  //Tax Service Registration
  const [ taxServiceRegistration, setTaxServiceRegistration ] = useState<TaxServiceRegistrationType> (initialTaxServiceRegistrationState)
  const [ taxServiceRegistrationValidity, setTaxServiceRegistrationValidity ] = useState<boolean> (false)
  const [ taxServiceRegistrationChecked, setTaxServiceRegistrationChecked ] = useState<boolean> (false)
  
  // ManagerWithQuality 
  const [managerWithQuality, setManagerWithQuality] = useState<ManagerTypeWithQualite>(initialManagerStatewithqualities)
  const [managerWithQualityValidity, setManagerWithQualityValidity] = useState<boolean>(false)
  const [managerWithQualityChecked, setManagerWithQualityChecked] = useState<boolean>(false)

  // new statutory auditor for Departure with replacement of the statutory auditor and alternate (ManagerType)
  const [newStatutoryAuditor, setNewStatutoryAuditor] = useState<ManagerType>(initialManagerState)
  const [newStatutoryAuditorValidity, setNewStatutoryAuditorValidity] = useState<boolean>(false)
  const [newStatutoryAuditorChecked, setNewStatutoryAuditorChecked] = useState<boolean>(false)

  // former statutory auditor alternate for Departure with replacement of the statutory auditor and alternate (ReduceManager)
  const [formerStatutoryAuditor, setFormerStatutoryAuditor] = useState<ReducedManagerType>(initialReducedManagerState)
  const [formerStatutoryAuditorValidity, setFormerStatutoryAuditorValidity] = useState<boolean>(false)
  const [formerStatutoryAuditorChecked, setFormerStatutoryAuditorChecked] = useState<boolean>(false)

  // new reduced statutory auditor for Departure with replacement of the statutory auditor and alternate(ManagerType)
  const [newAlternateAuditor, setNewAlternateAuditor] = useState<ManagerType>(initialManagerState)
  const [newAlternateAuditorValidity, setNewAlternateAuditorValidity] = useState<boolean>(false)
  const [newAlternateAuditorChecked, setNewAlternateAuditorChecked] = useState<boolean>(false)
  const [typeNewAlternateAuditorData, setTypeNewAlternateAuditorData] = useState<number>(0)

  // former reduced statutory auditor alternate for Departure with replacement of the statutory auditor and alternate (ReduceManager)
  const [formerAlternateAuditor, setFormerAlternateAuditor] = useState<ReducedManagerType>(initialReducedManagerState)
  const [formerAlternateAuditorValidity, setFormerAlternateAuditorValidity] = useState<boolean>(false)
  const [formerAlternateAuditorChecked, setFormerAlternateAuditorChecked] = useState<boolean>(false)
  const [typeFormerAlternateAuditorData, setTypeFormerAlternateAuditorData] = useState<number>(0)

  const [liquidators, setLiquidators] = useState<LiquidatorManagerType[]>(initialManagerListState)
  const [liquidatorValidity, setLiquidatorValidity] = useState<boolean>(false)
  const [liquidatorChecked, setLiquidatorChecked] = useState<boolean>(false)

  const [reducedManager, setReducedManager] = useState<ReducedManagerType>(initialReducedManagerState)
  const [reducedManagerValidity, setReducedManagerValidity] = useState<boolean>(false)
  const [reducedManagerChecked, setReducedManagerChecked] = useState<boolean>(false)

  const [reducedManagers, setReducedManagers] = useState<ReducedManagerType[]>([initialReducedManagerState])
  const [reducedManagersValidity, setReducedManagersValidity] = useState<boolean>(false)
  const [reducedManagersChecked, setReducedManagersChecked] = useState<boolean>(false)

  const [oldSecondAdministrator, setOldSecondAdministrator] = useState<ReducedManagerType>(initialReducedManagerState)
  const [oldSecondAdministratorValidity, setOldSecondAdministratorValidity] = useState<boolean>(false)
  const [oldSecondAdministratorChecked, setOldSecondAdministratorChecked] = useState<boolean>(false)
  const [typeOldAdministratorData, setTypeOldAdministratorData] = useState<number>(0)

  const [managers, setManagers] = useState<ManagerType[]>(initialManagerListState)
  const [managersValidity, setManagersValidity] = useState<boolean>(false)
  const [managersChecked, setManagersChecked] = useState<boolean>(false)

  const [companyName, setCompanyName] = useState<CompanyNameType>(companyNameInitialState)
  const [companyNameofficiant, setcompanyNameofficiant] = useState<CompanyNameType>(companyNameInitialState)
  const [legalEntityofficiant, setlegalEntityofficiant] = useState<LegalEntityTypeOfficiant>(officiantInitialState)
  const [Tribunal, setTribunal] = useState<Tribunal>(tribunalInitialState)
  const [heritier, setheritier] = useState<HeritierType>(heritierIndividualState)

  const [mode, setmode] = useState<LegalEntityTypeOfficiant>(officiantInitialState)
  const [companyNameValidity, setCompanyNameValidity] = useState<boolean>(false)
  const [companyNameChecked, setCompanyNameChecked] = useState<boolean>(false)

  const [companyNameUpdate, setCompanyNameUpdate] = useState<CompanyNameType>(companyNameInitialState);
  const [companyNameUpdateValidity, setCompanyNameUpdateValidity] = useState<boolean>(false);
  const [companyNameUpdateChecked, setCompanyNameUpdateChecked] = useState<boolean>(false);

  const [statusSignature, setStatusSignature] = useState<StatusSignatureType>(statusSignatureWithoutPlaceInitialState)
  const [statusSignatureValidity, setStatusSignatureValidity] = useState<boolean>(false)
  const [statusSignatureChecked, setStatusSignatureChecked] = useState<boolean>(false)

  const [theSociety, setTheSociety] = useState<TheSocietyType>(theSocietyFixedCapitalInitialState)
  const [theSocietyValidity, setTheSocietyValidity] = useState<boolean>(false)
  const [theSocietyChecked, setTheSocietyChecked] = useState<boolean>(false)

  const [headOfficeAddress, setHeadOfficeAddress] = useState<HeadOfficeAddressType>(headOfficeAddressInitialState)
  const [headOfficeAddressValidity, setHeadOfficeAddressValidity] = useState<boolean>(false)
  const [headOfficeAddressChecked, setHeadOfficeAddressChecked] = useState<boolean>(false)

  const [associates, setAssociates] = useState<ManagerType[]>(initialManagerListState)
  const [associatesValidity, setAssociatesValidity] = useState<boolean>(false)
  const [associatesChecked, setAssociatesChecked] = useState<boolean>(false)

  const [managersWithRepresentative, setManagersWithRepresentative] = useState<ManagerWithRepresentativeType[]>(managerListWithRepresentativeInitalState(3))
  const [managersWithRepresentativeValidity, setManagersWithRepresentativeValidity] = useState<boolean>(false)
  const [managersWithRepresentativeChecked, setManagersWithRepresentativeChecked] = useState<boolean>(false)

  const [managersWithRepresentativeList, setManagersWithRepresentativeList] = useState<ManagerWithRepresentativeType[]>(managerListWithRepresentativeInitalState(1))
  const [managersWithRepresentativeListValidity, setManagersWithRepresentativeListValidity] = useState<boolean>(false)
  const [managersWithRepresentativeListChecked, setManagersWithRepresentativeListChecked] = useState<boolean>(false)

  const [managerWithRepresentative, setManagerWithRepresentative] = useState<ManagerWithRepresentativeType>(managerWithRepresentativeInitalState)
  const [managerWithRepresentativeValidity, setManagerWithRepresentativeValidity] = useState<boolean>(false)
  const [managerWithRepresentativeChecked, setManagerWithRepresentativeChecked] = useState<boolean>(false)

  const [secondManagerWithRepresentative, setSecondManagerWithRepresentative] = useState<ManagerWithRepresentativeType>(managerWithRepresentativeInitalState)
  const [secondManagerWithRepresentativeValidity, setSecondManagerWithRepresentativeValidity] = useState<boolean>(false)
  const [secondManagerWithRepresentativeChecked, setSecondManagerWithRepresentativeChecked] = useState<boolean>(false)
  const [typeSecondManagerWithRepresentativeData, setTypeSecondManagerWithRepresentativeData] = useState<number>(0)

  const [statutoryAuditorWithRepresentative, setStatutoryAuditorWithRepresentative] = useState<ManagerWithRepresentativeType>(managerWithRepresentativeInitalState)
  const [statutoryAuditorWithRepresentativeValidity, setStatutoryAuditorWithRepresentativeValidity] = useState<boolean>(false)
  const [statutoryAuditorWithRepresentativeChecked, setStatutoryAuditorWithRepresentativeChecked] = useState<boolean>(false)

  const [deputyAuditorWithRepresentative, setDeputyAuditorWithRepresentative] = useState<ManagerWithRepresentativeType>(managerWithRepresentativeInitalState)
  const [deputyAuditorWithRepresentativeValidity, setDeputyAuditorWithRepresentativeValidity] = useState<boolean>(false)
  const [deputyAuditorWithRepresentativeChecked, setDeputyAuditorWithRepresentativeChecked] = useState<boolean>(false)

  const [councilMeeting, setCouncilMeeting] = useState<CouncilMeetingType>(councilMeetingInitialState)
  const [councilMeetingValidity, setCouncilMeetingValidity] = useState<boolean>(false)
  const [councilMeetingChecked, setCouncilMeetingChecked] = useState<boolean>(false)

  const [identity, setIdentity] = useState<IdentityType>(identityInitialState)
  const [identityValidity, setIdentityValidity] = useState<boolean>(false)
  const [identityChecked, setIdentityChecked] = useState<boolean>(false)

  const [decision, setDecision] = useState<DecisionType>(decisionInitialState);
  const [decisionValidity, setDecisionValidity] = useState<boolean>(false);
  const [decisionChecked, setDecisionChecked] = useState<boolean>(false);

  const [decisionWithQuality, setDecisionWithQuality] = useState<DecisionWithQualityType>(decisionWithQualityState);
  const [decisionWithQualityValidity, setDecisionWithQualityValidity] = useState<boolean>(false);
  const [decisionWithQualityChecked, setDecisionWithQualityChecked] = useState<boolean>(false);

  const [decisionWithQualityAndEffectiveDate, setDecisionWithQualityAndEffectiveDate] = useState<DecisionWithQualityType>(decisionWithQualityAndEffictiveDateState);
  const [decisionWithQualityAndEffectiveDateValidity, setDecisionWithQualityAndEffectiveDateValidity] = useState<boolean>(false);
  const [decisionWithQualityAndEffectiveDateChecked, setDecisionWithQualityAndEffectiveDateChecked] = useState<boolean>(false);

  const [decisionWithEffectiveDate, setDecisionWithEffectiveDate] = useState<DecisionType>(decisionWithEffectiveDateInitialState)
  const [DurationDateDébut, setDurationDateDébut] = useState<DurationManagementType>(durationInitialState)
  const [decisionWithEffectiveDateValidity, setDecisionWithEffectiveDateValidity] = useState<boolean>(false)
  const [durationDateDébutValidity, setdurationDateDébutValidity] = useState<boolean>(false)
  const [durationDateDébutChecked, setDurationDateDébutChecked] = useState<boolean>(false)
  const [decisionWithEffectiveDateChecked, setDecisionWithEffectiveDateChecked] = useState<boolean>(false)

  const [address, setAddress] = useState<AddressType>(addressInitialState)
  const [addressedeces, setAddressdeces] = useState<DateTypeDeces>(dateInitialStateDeces)
  const [addressValidity, setAddressValidity] = useState<boolean>(false)
  const [addressChecked, setAddressChecked] = useState<boolean>(false)

  // Location of oppositions for the same registry
  const [locationOppositionsRegistry, setLocationOppositionsRegistry] = useState<AddressType>(addressInitialState)
  const [locationOppositionsRegistryValidity, setLocationOppositionsRegistryValidity] = useState<boolean>(false)
  const [locationOppositionsRegistryChecked, setLocationOppositionsRegistryChecked] = useState<boolean>(false)

  // Location of oppositions for validity
  const [validityOppositionLocation, setValidityOppositionLocation] = useState<AddressType>(addressInitialState)
  const [validityOppositionLocationValidity, setValidityOppositionLocationValidity] = useState<boolean>(false)
  const [validityOppositionLocationChecked, setValidityOppositionLocationChecked] = useState<boolean>(false)

  const [date, setDate] = useState<DateType>(singleDateInitialState)
  const [datedeces, setdatedeces] = useState<DateType>(singleDateInitialState)
  const [DateTribunal, setDateTribunal] = useState<DateType>(singleDateInitialState)
  const [dateofficiant, setDateofficiant] = useState<LegalEntityTypeOfficiant>(officiantInitialState)
  const [dateValidity, setDateValidity] = useState<boolean>(false)
  const [dateValidityDeces, setDateValidityDeces] = useState<boolean>(false)
  const [personneeDecedeValidity, setpersonneeDecedeValidity] = useState<boolean>(false)
  const [officiantValidity, setofficiantValidity] = useState<boolean>(false)
  const [tribunalValidity, settribunalValidity] = useState<boolean>(false)
  const [heritierValidity, setheritierValidity] = useState<boolean>(false)
  const [dateChecked, setDateChecked] = useState<boolean>(false)
  const [datecheckedDeces, setdatecheckedDeces] = useState<boolean>(false)
  const [personneeDecedechecked, setpersonneeDecedechecked] = useState<boolean>(false)

  // Date of receipt
  const [ dateOfReceipt, setDateOfReceipt ] = useState<DateType>( singleDateInitialState)
  const [ dateOfReceiptValidity, setDateOfReceiptValidity ] = useState<boolean>( false )
  const [ dateOfReceiptChecked, setDateOfReceiptChecked ] = useState<boolean>( false )

  // Date of filing
  const [ dateOfFiling, setDateOfFiling ] = useState<DateType>( singleDateInitialState)
  const [ dateOfFilingValidity, setDateOfFilingValidity ] = useState<boolean>( false )
  const [ dateOfFilingChecked, setDateOfFilingChecked ] = useState<boolean>( false )

  // Date of will
  const [ dateOfWill, setDateOfWill ] = useState<DateType>( singleDateInitialState)
  const [ dateOfWillValidity, setDateOfWillValidity ] = useState<boolean>( false )
  const [ dateOfWillChecked, setDateOfWillChecked ] = useState<boolean>( false )

  const [dateNotary, setdateNotary] = useState<DateType>(singleDateInitialState)
  const [dateValidityNotary, setdateValidityNotary] = useState<boolean>(false)
  const [dateCheckedNotary, setdateCheckedNotary] = useState<boolean>(false)


  const [checkedofficiant, setcheckedofficiant] = useState<boolean>(false)
  const [checkedtribunal, setcheckedtribunal] = useState<boolean>(false)
  const [checkedHeritier, setcheckedHeritier] = useState<boolean>(false)

  const [datesignature, setDatesignature] = useState<DateTypesignature>(dateInitialStatesignature)
  const [dateValiditysignature, setDateValiditysignature] = useState<boolean>(false)
  const [dateCheckedsignature, setDateCheckedsignature] = useState<boolean>(false)
  // Date Of Birth And Cities
  const [dateOfBirth, setDateOfBirth] = useState<DateOfBirthAndCityType>(initialDateOfBirthAndCityState)
  const [dateOfBirthValidity, setDateOfBirthValidity] = useState<boolean>(false)
  const [dateOfBirthChecked, setDateOfBirthChecked] = useState<boolean>(false)

  // Date Registration Information
  const [registrationDate, setRegistrationDate] = useState<DateType>(singleDateInitialState)
  const [registrationDateValidity, setRegistrationDateValidity] = useState<boolean>(false)
  const [registrationDateChecked, setRegistrationDateChecked] = useState<boolean>(false)

  // Old Capital Change
  const [oldCapitalChange, setOldCapitalChange] = useState<CapitalType>({ capital: 0 })
  const [oldCapitalChangeValidity, setOldCapitalChangeValidity] = useState<boolean>(false)
  const [oldCapitalChangeChecked, setOldCapitalChangeChecked] = useState<boolean>(false)

  // New Capital Change  
  const [newCapitalChange, setNewCapitalChange] = useState<CapitalType>({ capital: 0 })
  const [newCapitalChangeValidity, setNewCapitalChangeValidity] = useState<boolean>(false)
  const [newCapitalChangeChecked, setNewCapitalChangeChecked] = useState<boolean>(false)

  const [dateWhithEffectiveDate, setDateWhithEffectiveDate] = useState<DateType>(dateInitialState)
  const [dateWhithEffectiveDateValidity, setDateWhithEffectiveDateValidity] = useState<boolean>(false)
  const [dateWhithEffectiveDateChecked, setDateWhithEffectiveDateChecked] = useState<boolean>(false)

  // Appointment of the auditor
  const [auditorsChange, setAuditorsChange] = useState<number>(0)

  // Family Situation
  const [ typeFamilySituationData, setTypeFamilySituationData ] = useState<number>(0)

  const [ typeTransformationOfSociety, setTypeTransformationOfSociety ] = useState<string> ('SAS')
  
  const [ typeTransformationOfSocietySARL, setTypeTransformationOfSocietySARL ] = useState<string> ('SARL')

  // Change Of Capital
  const [changeCapital, setChangeCapital] = useState<CapitalType>({ capital: 0 })
  const [changeCapitalValidity, setChangeCapitalValidity] = useState<boolean>(false)
  const [changeCapitalChecked, setChangeCapitalChecked] = useState<boolean>(false)

  // Capital Input
  const [transfertAmount, setTransfertAmount] = useState<CapitalType>({ capital: 0 })
  const [transfertAmountValidity, setTransfertAmountValidity] = useState<boolean>(false)
  const [transfertAmountChecked, setTransfertAmountChecked] = useState<boolean>(false)

  // Change Of Social Object
  const [changeSocialObject, setChangeSocialObject] = useState<ChangeSocialObjectType>(initialChangeSocialObjectState)
  const [changeSocialObjectValidity, setChangeSocialObjectValidity] = useState<boolean>(false)
  const [changeSocialObjectChecked, setChangeSocialObjectChecked] = useState<boolean>(false)

  // Managing Director List
  const [generalManagers, setGeneralManagers] = useState<ManagerType[]>(initialManagerListState);
  const [generalManagersValidity, setGeneralManagersValidity] = useState<boolean>(false);
  const [generalManagersChecked, setGeneralManagersChecked] = useState<boolean>(false);
  const [typeGeneralManagersData, setTypeGeneralManagersData] = useState<number>(0);

  // Affected Individuals List
  const [affectedIndividuals, setAffectedIndividuals] = useState<AffectedIndividualsType[]>([initialAffectedIndividualsState]);
  const [affectedIndividualsValidity, setAffectedIndividualsValidity] = useState<boolean>(false);
  const [affectedIndividualsChecked, setAffectedIndividualsChecked] = useState<boolean>(false);
  const [typeAffectedIndividualsData, setTypeAffectedIndividualsData] = useState<number>(0);

  // Managing List with Quality 
  const [generalManagersWithQualite, setGeneralManagersWithQualite] = useState<ManagerTypeWithQualite[]>(initialManagerListStatewithQualities);
  const [generalManagersWithQualiteValidity, setGeneralManagersWithQualiteValidity] = useState<boolean>(false);
  const [generalManagersWithQualiteChecked, setGeneralManagersWithQualiteChecked] = useState<boolean>(false);
  const [typeGeneralManagersWithQualiteData, setTypeGeneralManagersWithQualiteData] = useState<number>(0);

  // Managing List with Quality Reduced
  const [reducedGeneralManagersWithQualite, setReducedGeneralManagersWithQualite] = useState<ReducedManagerTypeWithQuality[]>(initialReducedManagerListStatewithQualities);
  const [reducedGeneralManagersWithQualiteValidity, setReducedGeneralManagersWithQualiteValidity] = useState<boolean>(false);
  const [reducedGeneralManagersWithQualiteChecked, setReducedGeneralManagersWithQualiteChecked] = useState<boolean>(false);

  // executiveOfficers
  const [executiveOfficers, setExecutiveOfficers] = useState<ManagerType[]>(initialManagerListState);
  const [executiveOfficersValidity, setExecutiveOfficersValidity] = useState<boolean>(false);
  const [executiveOfficersChecked, setExecutiveOfficersChecked] = useState<boolean>(false);
  const [typeExecutiveOfficersData, setTypeExecutiveOfficersData] = useState<number>(0);

  // statutoryAuditor
  const [statutoryAuditor, setStatutoryAuditor] = useState<ManagerType>(initialManagerState);
  const [statutoryAuditorValidity, setStatutoryAuditorValidity] = useState<boolean>(false);
  const [statutoryAuditorChecked, setStatutoryAuditorChecked] = useState<boolean>(false);
  const [typeStatutoryAuditorData, setTypeStatutoryAuditorData] = useState<number>(0);

  // AlternateAuditor
  const [alternateAuditor, setAlternateAuditor] = useState<ManagerType>(initialManagerState);
  const [alternateAuditorValidity, setAlternateAuditorValidity] = useState<boolean>(false);
  const [alternateAuditorChecked, setAlternateAuditorChecked] = useState<boolean>(false);
  const [typeAlternateAuditorData, setTypeAlternateAuditorData] = useState<number>(0);


  const [absorbedCompany, setAbsorbedCompany] = useState<LegalEntityType>(initialLegalEntityState);
  const [absorbedCompanyChecked, setAbsorbedCompanyChecked] = useState<boolean>(false)
  const [absorbedCompanyValidity, setAbsorbedCompanyValidity] = useState<boolean>(false)

  const [absorbingCompany, setAbsorbingCompany] = useState<LegalEntityType>(initialLegalEntityState);
  const [absorbingCompanyChecked, setAbsorbingCompanyChecked] = useState<boolean>(false);
  const [absorbingCompanyValidity, setAbsorbingCompanyValidity] = useState<boolean>(false);

  const [leaderChange, setLeaderChange] = useState<LeaderChangeType>(leaderChangeInitialState);
  const [leaderChangeValidity, setLeaderChangeValidity] = useState<boolean>(false)
  const [leaderChangeChecked, setLeaderChangeChecked] = useState<boolean>(false)

  const [partnerChange, setPartnerChange] = useState<PartnerChangeType>(partnerChangeInitialState);
  const [partnerChangeValidity, setPartnerChangeValidity] = useState<boolean>(false)
  const [partnerChangeChecked, setPartnerChangeChecked] = useState<boolean>(false)

  const [ typeHeirsData, setTypeHeirsData ] = useState<number>( 0 )

  const [typeGeneralManagerData, setTypeGeneralManagerData] = useState<number>(0)
  const [liquidationHeadquarter, setLiquidationHeadquarter] = useState<string>("Au siège social")
  const [typeAddress, setTypeAddress] = useState<number>(0)

  const [clause, setClause] = useState<Clause>(clauseinitial)
  const [admission, setAdmission] = useState<admissionToMeetingType>(initialAdmissionToMeetingState)

  const [inputGeneralDirector, setInputGeneralDirector] = useState<number>(0)

  const  [ notaryData, setNotaryData ] = useState<number> (0)

  const [profilePicture, setProfilePicture] = useState<string | null>(null);

  // Admission description text
  const [admissionDescriptionText, setAdmissionDescriptionText] = useState<DescriptionTextType>(initialDescriptionTextState)
  const [admissionDescriptionTextValidity, setAdmissionDescriptionTextValidity] = useState<boolean>(false)
  const [admissionDescriptionTextChecked, setAdmissionDescriptionTextChecked] = useState<boolean>(false)

  // Clause description text
  const [clauseDescriptionText, setClauseDescriptionText] = useState<DescriptionTextType>(initialDescriptionTextState)
  const [clauseDescriptionTextValidity, setClauseDescriptionTextValidity] = useState<boolean>(false)
  const [clauseDescriptionTextChecked, setClauseDescriptionTextChecked] = useState<boolean>(false)

  // MULTIPLE CHANGES
  // manager and presidency change
  const [managerAndPresidencyChange, setManagerAndPresidencyChange] = useState<number>(0)

  // Denomination change
  const [companyNameChange, setCompanyNameChange] = useState<number>(0)

  // Social object change
  const [socialObjectChange, setSocialObjectChange] = useState<number>(0)

  // Social capital change
  const [socialCapitalChange, setSocialCapitalChange] = useState<number>(0)

  // Duration change
  const [durationChange, setDurationChange] = useState<number>(0)

  // Auditor change
  const [auditorChange, setAuditorChange] = useState<number>(0)

  // Seat transfert change
  const [seatTransfertChange, setSeatTransfertChange] = useState<number>(0)


  // manager and presidency change effective date
  const [presidencyChangeEffectiveDate, setPresidencyChangeEffectiveDate] = useState<DateType>(singleDateInitialState)
  const [presidencyChangeEffectiveDateValidity, setPresidencyChangeEffectiveDateValidity] = useState<boolean>(false)
  const [presidencyChangeEffectiveDateChecked, setPresidencyChangeEffectiveDateChecked] = useState<boolean>(false)

  // company name change effective date
  const [companyNameChangeEffectiveDate, setCompanyNameChangeEffectiveDate] = useState<DateType>(singleDateInitialState)
  const [companyNameChangeEffectiveDateValidity, setCompanyNameChangeEffectiveDateValidity] = useState<boolean>(false)
  const [companyNameChangeEffectiveDateChecked, setCompanyNameChangeEffectiveDateChecked] = useState<boolean>(false)

  // social object change effective date
  const [socialObjectChangeEffectiveDate, setSocialObjectChangeEffectiveDate] = useState<DateType>(singleDateInitialState)
  const [socialObjectChangeEffectiveDateValidity, setSocialObjectChangeEffectiveDateValidity] = useState<boolean>(false)
  const [socialObjectChangeEffectiveDateChecked, setSocialObjectChangeEffectiveDateChecked] = useState<boolean>(false)

  // social capital change effective date
  const [socialCapitalChangeEffectiveDate, setSocialCapitalChangeEffectiveDate] = useState<DateType>(singleDateInitialState)
  const [socialCapitalChangeEffectiveDateValidity, setSocialCapitalChangeEffectiveDateValidity] = useState<boolean>(false)
  const [socialCapitalChangeEffectiveDateChecked, setSocialCapitalChangeEffectiveDateChecked] = useState<boolean>(false)

  // duration change effective date
  const [durationChangeEffectiveDate, setDurationChangeEffectiveDate] = useState<DateType>(singleDateInitialState)
  const [durationChangeEffectiveDateValidity, setDurationChangeEffectiveDateValidity] = useState<boolean>(false)
  const [durationChangeEffectiveDateChecked, setDurationChangeEffectiveDateChecked] = useState<boolean>(false)

  // duration change date
  const [durationChangeDate, setDurationChangeDate] = useState<DateType>(singleDateInitialState)
  const [durationChangeDateValidity, setDurationChangeDateValidity] = useState<boolean>(false)
  const [durationChangeDateChecked, setDurationChangeDateChecked] = useState<boolean>(false)

  // auditor change effective date
  const [auditorChangeEffectiveDate, setAuditorChangeEffectiveDate] = useState<DateType>(singleDateInitialState)
  const [auditorChangeEffectiveDateValidity, setAuditorChangeEffectiveDateValidity] = useState<boolean>(false)
  const [auditorChangeEffectiveDateChecked, setAuditorChangeEffectiveDateChecked] = useState<boolean>(false)

  // seat transfert change effective date
  const [seatTransfertChangeEffectiveDate, setseatTransfertChangeEffectiveDate] = useState<DateType>(singleDateInitialState)
  const [seatTransfertChangeEffectiveDateValidity, setseatTransfertChangeEffectiveDateValidity] = useState<boolean>(false)
  const [seatTransfertChangeEffectiveDateChecked, setseatTransfertChangeEffectiveDateChecked] = useState<boolean>(false)

  // reduced statutoryAuditor
  const [reducedStatutoryAuditor, setReducedStatutoryAuditor] = useState<ReducedManagerType>(initialReducedManagerState);
  const [reducedStatutoryAuditorValidity, setReducedStatutoryAuditorValidity] = useState<boolean>(false);
  const [reducedStatutoryAuditorChecked, setReducedStatutoryAuditorChecked] = useState<boolean>(false);

  // Type Registration Data
  const [typeRegistrationData, setTypeRegistrationData] = useState<'bordereau' | 'dossier'>(registrationNotices.numberProvided);

  const [typeOppositionData, setTypeOppositionData] = useState<number>(0);


  // cédant
  const [sellerManager, setSellerManager] = useState<ManagerType>(initialManagerState)
  const [sellerManagerValidity, setSellerManagerValidity] = useState<boolean>(false)
  const [sellerManagerChecked, setSellerManagerChecked] = useState<boolean>(false)

  // acquéreur
  const [buyerManager, setBuyerManager] = useState<ManagerType>(initialManagerState)
  const [buyerManagerValidity, setBuyerManagerValidity] = useState<boolean>(false)
  const [buyerManagerChecked, setBuyerManagerChecked] = useState<boolean>(false)


  // activité du fonds
  const [fundActivity, setFundActivity] = useState<TextareaType>(textAreaInitalState);
  const [fundActivityValidity, setFundActivityValidity] = useState<boolean>(false);
  const [fundActivityChecked, setFundActivityChecked] = useState<boolean>(false);

  // actéléments du fonds
  const [fundElements, setFundElements] = useState<TextareaType>(textAreaInitalState);
  const [fundElementsValidity, setFundElementsValidity] = useState<boolean>(false);
  const [fundElementsChecked, setFundElementsChecked] = useState<boolean>(false);

  // Death Related Info
  const [ deathRelatedInfo, setDeathRelatedInfo ] = useState<DeathRelatedInfoType>( initialDeathRelatedInfoState )
  const [ deathRelatedInfoValidity, setDeathRelatedInfoValidity ] = useState<boolean>( false )
  const [ deathRelatedInfoChecked, setDeathRelatedInfoChecked ] = useState<boolean>( false )

  // New Name
  const [ fullName, setFullName ] = useState<NewNameType> (initialNewNameState)

  // déclaration d'insaisissabilité
  const [ registrationReference, setRegistrationReference ] = useState<RegistrationReferenceType>( registrationReferenceInitialState );
  const [ registrationReferenceValidity, setRegistrationReferenceValidity ] = useState<boolean>( false );
  const [ registrationReferenceChecked, setRegistrationReferenceChecked ] = useState<boolean>( false );

  const [ notaryContact, setNotaryContact ] = useState<NotaryContactType>( notaryContactInitialState );
  const [ notaryContactValidity, setNotaryContactValidity ] = useState<boolean>( false );
  const [ notaryContactChecked, setNotaryContactChecked ] = useState<boolean>( false );

  const [ applicant, setApplicant ] = useState<IndividualWithFamilySituationType>( individualWithFamilySituationInitialState );
  const [ applicantValidity, setApplicantValidity ] = useState<boolean>( false );
  const [ applicantChecked, setApplicantChecked ] = useState<boolean>( false );
  
  const [ mariageContract, setMariageContract ] = useState<MariageContractType>( mariageContractInitialState );

  const [ residentialAddress, setResidentialAddress ] = useState<AddressType>( addressInitialState );
  const [ residentialAddressValidity, setResidentialAddressValidity ] = useState<boolean>( false );
  const [ residentialAddressChecked, setResidentialAddressChecked ] = useState<boolean>( false );

  const [ mainResidenceAddress, setMainResidenceAddress ] = useState<AddressType>( addressInitialState );
  const [ mainResidenceAddressValidity, setMainResidenceAddressValidity ] = useState<boolean>( false );
  const [ mainResidenceAddressChecked, setMainResidenceAddressChecked ] = useState<boolean>( false );

  const [ deathDate, setDeathDate ] = useState<DateType>( singleDateInitialState )

  
  // changement de régime matrimonial
  
  const [ spouseNumberOne, setSpouseNumberOne ] = useState<IndividualWithProfessionType>( individualWithProfessionInitialState )
  const [ spouseNumberOneValidity, setSpouseNumberOneValidity ] = useState<boolean>( false )
  const [ spouseNumberOneChecked, setSpouseNumberOneChecked ] = useState<boolean>( false )

  const [ spouseOneBirth, setSpouseOneBirth ] = useState<DateOfBirthAndCityType>( initialDateOfBirthAndCityState )
  const [ spouseOneBirthValidity, setSpouseOneBirthValidity ] = useState<boolean>( false )
  const [ spouseOneBirthChecked, setSpouseOneBirthChecked ] = useState<boolean>( false )
  
  const [ spouseNumberTwo, setSpouseNumberTwo ] = useState<IndividualWithProfessionType>( individualWithProfessionInitialState )
  const [ spouseNumberTwoValidity, setSpouseNumberTwoValidity ] = useState<boolean>( false )
  const [ spouseNumberTwoChecked, setSpouseNumberTwoChecked ] = useState<boolean>( false )

  const [ spouseTwoBirth, setSpouseTwoBirth ] = useState<DateOfBirthAndCityType>( initialDateOfBirthAndCityState )
  const [ spouseTwoBirthValidity, setSpouseTwoBirthValidity ] = useState<boolean>( false )
  const [ spouseTwoBirthChecked, setSpouseTwoBirthChecked ] = useState<boolean>( false )

  const [ spousesAddress, setSpousesAddress ] = useState<HeadOfficeAddressType>( headOfficeAddressInitialState )
  const [ spousesAddressValidity, setSpousesAddressValidity ] = useState<boolean>( false )
  const [ spousesAddressChecked, setSpousesAddressChecked ] = useState<boolean>( false )

  const [ previousRegime, setPreviousRegime ] = useState<PreviousMaritalRegimeType>( previousMaritalRegimeInitialState )
  const [ previousRegimeValidity, setPreviousRegimeValidity ] = useState<boolean>( false )
  const [ previousRegimeChecked, setPreviousRegimeChecked ] = useState<boolean>( false )

  const [ newRegime, setNewRegime ] = useState<string>( "Communauté de biens réduite aux acquêts" )

  const [ typeNotaryData, setTypeNotaryData ] = useState<number>( 0 )

  const [ contractDate, setcontractDate ] = useState<DateType>( singleDateInitialState )

  const [ officiatingNotary, setOfficiatingNotary ] = useState<IndividualPersonType>( initialIndividualState )
  const [ officiatingNotaryValidity, setOfficiatingNotaryValidity ] = useState<boolean>( false )
  const [ officiatingNotaryChecked, setOfficiatingNotaryChecked ] = useState<boolean>( false )
  
  const [ oppositionsNotary, setOppositionsNotary ] = useState<IndividualPersonType>( initialIndividualState )
  const [ oppositionsNotaryValidity, setOppositionsNotaryValidity ] = useState<boolean>( false )
  const [ oppositionsNotaryChecked, setOppositionsNotaryChecked ] = useState<boolean>( false )

  const [ denomination, setDenomination ] = useState<string>('')

  const [ legalForm, setLegalForm ] = useState<string>('')
  
  const [ clientReference, setClientReference ] = useState<string>('')
  
  const [ texteAnnonce, setTexteAnnonce ] = useState<string>('')

  const [ logos, setLogos ] = useState<LogoType[]>([])

  // User Information
  const [userName, setUserName] = useState<string>('');
  const [userFirstname, setUserFirstname] = useState<string>('');

  const [status,setUserStatus]=useState<string>('')

  // announcement logoID and header
  const [entete, setEntete] = useState<string>("")
  const [floid, setFloid] = useState<string>("")
  const [logoLibelle, setLogoLibelle] = useState<string>("")
  const [choix, setChoix] = useState<string>('option1')

  const [pointsToUse, setPointsToUse] = useState<number>(0);
  const [userPoints, setUserPoints] = useState<number>(0);

  const clearContext = () => {

    setAuthenticatedUser(null)

    setCurrentAnnonceId( null )

    //autoDiscount
    setAutoDiscount(0)

    //userAnnonces
    setUserAnnonces([])

    // Discount Id
    setDiscountId( null )

    setDiscountAmount (0)
    
    setPressSupportPostalCode('')
    setPressSupportCity('')

    setCurrentAnnoucement( null )
    
    setRegistrationNotices(initialRegistrationNoticesState)
    setRegistrationNoticesValidity(false)
    setRegistrationNoticesChecked(false)

    setIndividual(initialIndividualState)
    setIndividualValidity(false)
    setIndividualChecked(false)

    setIndividualNotary( initialIndividualState )
    setIndividualNotaryValidity( false )
    setIndividualNotaryChecked( false )

    // individual With Birth Name
    setIndividualWithBirthName(initialIndividualWithBirthNameState)
    setIndividualWithBirthNameValidity(false)
    setIndividualWithBirthNameChecked(false)


    setIndividualPersons([initialIndividualState])
    setIndividualPersonsValidity(false)
    setIndividualPersonsChecked(false)

    setReducedIndividualPerson(initialReducedIndividualState)
    setReducedIndividualPersonValidity(false)
    setReducedIndividualPersonChecked(false)

    setLegalEntity(initialLegalEntityState);
    setLegalEntityValidity(false);
    setLegalEntityChecked(false);

    setSigningOfTheStatus(initialSigningOfTheStatusState)
    setSigningOfTheStatusValidity(false)
    setSigningOfTheStatusChecked(false)

    setReducedLegalEntity(initialReducedLegalEntityState)
    setReducedLegalEntityValidity(false)
    setReducedLegalEntityChecked(false)

    setManager(initialManagerState)
    setManagerValidity(false)
    setManagerChecked(false)

    setManagerWithQuality(initialManagerStatewithqualities)
    setManagerWithQualityValidity(false)
    setManagerWithQualityChecked(false)

    setNewStatutoryAuditor(initialManagerState)
    setNewStatutoryAuditorValidity(false)
    setNewStatutoryAuditorChecked(false)

    setFormerStatutoryAuditor(initialReducedManagerState)
    setFormerStatutoryAuditorValidity(false)
    setFormerStatutoryAuditorChecked(false)

    setNewAlternateAuditor(initialManagerState)
    setNewAlternateAuditorValidity(false)
    setNewAlternateAuditorChecked(false)
    setTypeNewAlternateAuditorData(0)

    setFormerAlternateAuditor(initialReducedManagerState)
    setFormerAlternateAuditorValidity(false)
    setFormerAlternateAuditorChecked(false)
    setTypeFormerAlternateAuditorData(0)

    setLiquidators(initialManagerListState)
    setLiquidatorValidity(false)
    setLiquidatorChecked(false)

    setReducedManager(initialReducedManagerState)
    setReducedManagerValidity(false)
    setReducedManagerChecked(false)

    setReducedManagers([initialReducedManagerState])
    setReducedManagersValidity(false)
    setReducedManagersChecked(false)

    setManagers(initialManagerListState)
    setManagersValidity(false)
    setManagersChecked(false)

    setCompanyName(companyNameInitialState)
    setCompanyNameChecked(false)
    setCompanyNameValidity(false)

    setCompanyNameUpdate(companyNameInitialState)
    setCompanyNameUpdateChecked(false)
    setCompanyNameUpdateValidity(false)

    setStatusSignature(statusSignatureWithoutPlaceInitialState)
    setStatusSignatureChecked(false)
    setStatusSignatureValidity(false)

    setTheSociety(theSocietyFixedCapitalInitialState)
    setTheSocietyChecked(false)
    setTheSocietyValidity(false)

    setHeadOfficeAddress(headOfficeAddressInitialState)
    setHeadOfficeAddressChecked(false)
    setHeadOfficeAddressValidity(false)

    setAssociates(initialManagerListState)
    setAssociatesChecked(false)
    setAssociatesValidity(false)

    setManagersWithRepresentative(managerListWithRepresentativeInitalState(3))
    setManagersWithRepresentativeValidity(false)
    setManagersWithRepresentativeChecked(false)

    setManagersWithRepresentativeList(managerListWithRepresentativeInitalState(1))
    setManagersWithRepresentativeListValidity(false)
    setManagersWithRepresentativeListChecked(false)

    setManagerWithRepresentative(managerWithRepresentativeInitalState)
    setManagerWithRepresentativeValidity(false)
    setManagerWithRepresentativeChecked(false)

    setSecondManagerWithRepresentative(managerWithRepresentativeInitalState)
    setSecondManagerWithRepresentativeValidity(false)
    setSecondManagerWithRepresentativeChecked(false)
    setTypeSecondManagerWithRepresentativeData(0)

    setStatutoryAuditorWithRepresentative(managerWithRepresentativeInitalState)
    setStatutoryAuditorWithRepresentativeValidity(false)
    setStatutoryAuditorWithRepresentativeChecked(false)

    setDeputyAuditorWithRepresentative(managerWithRepresentativeInitalState)
    setDeputyAuditorWithRepresentativeValidity(false)
    setDeputyAuditorWithRepresentativeChecked(false)

    setCouncilMeeting(councilMeetingInitialState)
    setCouncilMeetingValidity(false)
    setCouncilMeetingChecked(false)

    setIdentity(identityInitialState)
    setIdentityValidity(false)
    setIdentityChecked(false)

    setDecision(decisionInitialState);
    setDecisionValidity(false)
    setDecisionChecked(false)

    setDecisionWithQuality(decisionWithQualityState);
    setDecisionWithQualityValidity(false)
    setDecisionWithQualityChecked(false)

    setDecisionWithQualityAndEffectiveDate(decisionWithQualityAndEffictiveDateState);
    setDecisionWithQualityAndEffectiveDateValidity(false)
    setDecisionWithQualityAndEffectiveDateChecked(false)

    setDecisionWithEffectiveDate(decisionWithEffectiveDateInitialState)
    setDurationDateDébut(durationInitialState)
    setDecisionWithEffectiveDateValidity(false)
    setDecisionWithEffectiveDateChecked(false)

    setAddress(addressInitialState)
    setAddressValidity(false)
    setAddressChecked(false)

    setLocationOppositionsRegistry(addressInitialState)
    setLocationOppositionsRegistryValidity(false)
    setLocationOppositionsRegistryChecked(false)

    setValidityOppositionLocation(addressInitialState)
    setValidityOppositionLocationValidity(false)
    setValidityOppositionLocationChecked(false)

    setDate(singleDateInitialState)
    setDateValidity(false)
    setDateChecked(false)

    setDateOfReceipt( singleDateInitialState)
    setDateOfReceiptValidity( false )
    setDateOfReceiptChecked( false )

    setDateOfFiling( singleDateInitialState)
    setDateOfFilingValidity( false )
    setDateOfFilingChecked( false )

    setDateOfWill( singleDateInitialState)
    setDateOfWillValidity( false )
    setDateOfWillChecked( false )

    setDateOfBirth(initialDateOfBirthAndCityState)
    setDateOfBirthValidity(false)
    setDateOfBirthChecked(false)

    setRegistrationDate(singleDateInitialState)
    setRegistrationDateValidity(false)
    setRegistrationDateChecked(false)

    setOldCapitalChange({ capital: 0 })
    setOldCapitalChangeValidity(false)
    setOldCapitalChangeChecked(false)

    setNewCapitalChange({ capital: 0 })
    setNewCapitalChangeValidity(false)
    setNewCapitalChangeChecked(false)

    setGeneralManagers(initialManagerListState);
    setGeneralManagersValidity(false);
    setGeneralManagersChecked(false);
    setTypeGeneralManagersData(0);

    // Managing List with Quality 
    setGeneralManagersWithQualite(initialManagerListStatewithQualities);
    setGeneralManagersWithQualiteValidity(false);
    setGeneralManagersWithQualiteChecked(false);
    setTypeGeneralManagersWithQualiteData(0)

    // Affected Individuals List
    setAffectedIndividuals([initialAffectedIndividualsState]);
    setAffectedIndividualsValidity(false);
    setAffectedIndividualsChecked(false);
    setTypeAffectedIndividualsData(0)

    setReducedGeneralManagersWithQualite(initialReducedManagerListStatewithQualities)
    setReducedGeneralManagersWithQualiteValidity(false);
    setReducedGeneralManagersWithQualiteChecked(false);

    setExecutiveOfficers(initialManagerListState);
    setExecutiveOfficersValidity(false);
    setExecutiveOfficersChecked(false);
    setTypeExecutiveOfficersData(0);

    setTaxServiceRegistration(initialTaxServiceRegistrationState)
    setTaxServiceRegistrationValidity(false);
    setTaxServiceRegistrationChecked(false);

    setStatutoryAuditor(initialManagerState);
    setStatutoryAuditorValidity(false);
    setStatutoryAuditorChecked(false);
    setTypeStatutoryAuditorData(0);

    setAlternateAuditor(initialManagerState);
    setAlternateAuditorValidity(false);
    setAlternateAuditorChecked(false);
    setTypeAlternateAuditorData(0);

    setAbsorbedCompany(initialLegalEntityState);
    setAbsorbedCompanyChecked(false)
    setAbsorbedCompanyValidity(false)

    setAbsorbingCompany(initialLegalEntityState);
    setAbsorbingCompanyChecked(false);
    setAbsorbingCompanyValidity(false);

    setLeaderChange(leaderChangeInitialState);
    setLeaderChangeValidity(false)
    setLeaderChangeChecked(false)

    setPartnerChange(partnerChangeInitialState);
    setPartnerChangeValidity(false)
    setPartnerChangeChecked(false)

    setTypeGeneralManagerData(0)
    setLiquidationHeadquarter("Au siège social")
    setTypeAddress(0)

    setTypeHeirsData( 0 )

    setNotaryData(0)

    setClause( clauseinitial )
    setAdmission( initialAdmissionToMeetingState )

    setAdmissionDescriptionText(initialDescriptionTextState)
    setAdmissionDescriptionTextValidity(false)
    setAdmissionDescriptionTextChecked(false)

    setClauseDescriptionText(initialDescriptionTextState)
    setClauseDescriptionTextValidity(false)
    setClauseDescriptionTextChecked(false)

    setTypeTransformationOfSocietySARL('SARL')

    setInputGeneralDirector(0)

    // New Last Name
    setNewLastName('')
    setNewLastNameValidity(false)
    setNewLastNameChecked(false)
    setTypeNewLastNameData(0)

    //MULTIPLE CHANGES
    setManagerAndPresidencyChange(0);
    setCompanyNameChange(0)
    setSocialObjectChange(0)
    setSocialCapitalChange(0)
    setDurationChange(0)
    setAuditorChange(0)
    setSeatTransfertChange(0)

    // manager and presidency change effective date
    setPresidencyChangeEffectiveDate(singleDateInitialState)
    setPresidencyChangeEffectiveDateValidity(false)
    setPresidencyChangeEffectiveDateChecked(false)

    // company name change effective date
    setCompanyNameChangeEffectiveDate(singleDateInitialState)
    setCompanyNameChangeEffectiveDateValidity(false)
    setCompanyNameChangeEffectiveDateChecked(false)

    // social object change effective date
    setSocialObjectChangeEffectiveDate(singleDateInitialState)
    setSocialObjectChangeEffectiveDateValidity(false)
    setSocialObjectChangeEffectiveDateChecked(false)

    // social capital change effective date
    setSocialCapitalChangeEffectiveDate(singleDateInitialState)
    setSocialCapitalChangeEffectiveDateValidity(false)
    setSocialCapitalChangeEffectiveDateChecked(false)

    // duration change effective date
    setDurationChangeEffectiveDate(singleDateInitialState)
    setDurationChangeEffectiveDateValidity(false)
    setDurationChangeEffectiveDateChecked(false)

    // duration change  date
    setDurationChangeDate(singleDateInitialState)
    setDurationChangeDateValidity(false)
    setDurationChangeDateChecked(false)

    // auditor change effective date
    setAuditorChangeEffectiveDate(singleDateInitialState)
    setAuditorChangeEffectiveDateValidity(false)
    setAuditorChangeEffectiveDateChecked(false)

    // seat transfert change effective date
    setseatTransfertChangeEffectiveDate(singleDateInitialState)
    setseatTransfertChangeEffectiveDateValidity(false)
    setseatTransfertChangeEffectiveDateChecked(false)

    // reduced statutoryAuditor
    setReducedStatutoryAuditor(initialReducedManagerState);
    setReducedStatutoryAuditorValidity(false);
    setReducedStatutoryAuditorChecked(false);

    setTypeRegistrationData('bordereau');
    setTypeOppositionData(0);


    // cédant
    setSellerManager(initialManagerState)
    setSellerManagerValidity(false)
    setSellerManagerChecked(false)

    // acquéreur
    setBuyerManager(initialManagerState)
    setBuyerManagerValidity(false)
    setBuyerManagerChecked(false)


    // activité du fonds
    setFundActivity(textAreaInitalState);
    setFundActivityValidity(false);
    setFundActivityChecked(false);

    // actéléments du fonds
    setFundElements(textAreaInitalState);
    setFundElementsValidity(false);
    setFundElementsChecked(false);

    // Death Related Info
    setDeathRelatedInfo ( initialDeathRelatedInfoState );
    setDeathRelatedInfoValidity( false );
    setDeathRelatedInfoChecked( false );

    setFullName (initialNewNameState);

    setTypeFamilySituationData(0);
     // déclaration d'insaisissabilité
    setRegistrationReference( registrationReferenceInitialState );
    setRegistrationReferenceValidity( false );
    setRegistrationReferenceChecked( false );

    setNotaryContact( notaryContactInitialState );
    setNotaryContactValidity( false );
    setNotaryContactChecked( false );

    setApplicant( individualWithFamilySituationInitialState );
    setApplicantValidity( false );
    setApplicantChecked( false );
    
    setMariageContract( mariageContractInitialState );

    setResidentialAddress( addressInitialState );
    setResidentialAddressValidity( false );
    setResidentialAddressChecked( false );

    setMainResidenceAddress( addressInitialState );
    setMainResidenceAddressValidity( false );
    setMainResidenceAddressChecked( false );

    setDeathDate( singleDateInitialState );

    
    setSpouseNumberOne( individualWithProfessionInitialState )
    setSpouseNumberOneValidity( false )
    setSpouseNumberOneChecked( false )

    setSpouseOneBirth( initialDateOfBirthAndCityState )
    setSpouseOneBirthValidity( false )
    setSpouseOneBirthChecked( false )
    
    setSpouseNumberTwo( individualWithProfessionInitialState )
    setSpouseNumberTwoValidity( false )
    setSpouseNumberTwoChecked( false )

    setSpouseTwoBirth( initialDateOfBirthAndCityState )
    setSpouseTwoBirthValidity( false )
    setSpouseTwoBirthChecked( false )

    setSpousesAddress( headOfficeAddressInitialState )
    setSpousesAddressValidity( false )
    setSpousesAddressChecked( false )

    setPreviousRegime( previousMaritalRegimeInitialState )
    setPreviousRegimeValidity( false )
    setPreviousRegimeChecked( false )

    setNewRegime( "Communauté de biens réduite aux acquêts" )

    setTypeNotaryData( 0 )

    setcontractDate( singleDateInitialState )

    setOfficiatingNotary( initialIndividualState )
    setOfficiatingNotaryValidity( false )
    setOfficiatingNotaryChecked( false )
    
    setOppositionsNotary( initialIndividualState )
    setOppositionsNotaryValidity( false )
    setOppositionsNotaryChecked( false )

    setDenomination('')
    setLegalForm('')
    setClientReference('')
    setTexteAnnonce('')

    setUserName('')
    setUserFirstname('')

    
    // announcement logoID and header
    setEntete("")
    setFloid("")
    setLogoLibelle("")
    setChoix('option1')

    setPointsToUse( 0 )

  }

  return (
    <AppContext.Provider value={{

      authenticatedUser,
      setAuthenticatedUser,

      currentAnnonceId,
      setCurrentAnnonceId,

      clearContext,

      // autoDiscount
      autoDiscount,
      setAutoDiscount,

      //userAnnonces
      userAnnonces,
      setUserAnnonces,

      // Discount Id
      discountId,
      setDiscountId,

      discountAmount,
      setDiscountAmount,

      pressSupportPostalCode,
      setPressSupportPostalCode,

      announcementTypeList,
      setAnnouncementTypeList,

      selectedType,
      setSelectedType,

      pressSupportCity,
      setPressSupportCity,

      currentAnnoucement,
      setCurrentAnnoucement,

      activeIndex,
      setActiveIndex,
      checkedIndex,
      setCheckedIndex,

      lastTab,
      setLastTab,

      draftFormData,
      setDraftFormData,

      registrationNotices,
      setRegistrationNotices,
      registrationNoticesValidity,
      setRegistrationNoticesValidity,
      registrationNoticesChecked,
      setRegistrationNoticesChecked,

      individual,
      setIndividual,
      individualValidity,
      setIndividualValidity,
      individualChecked,
      setIndividualChecked,

      individualNotary,
      setIndividualNotary,
      individualNotaryValidity,
      setIndividualNotaryValidity,
      individualNotaryChecked,
      setIndividualNotaryChecked,

      // individual With Birth Name
      individualWithBirthName,
      setIndividualWithBirthName,
      individualWithBirthNameValidity,
      setIndividualWithBirthNameValidity,
      individualWithBirthNameChecked,
      setIndividualWithBirthNameChecked,


      individualPersons,
      setIndividualPersons,
      individualPersonsValidity,
      setIndividualPersonsValidity,
      individualPersonsChecked,
      setIndividualPersonsChecked,


      individualPersonsHeritier,
      setIndividualPersonsHeritier,
      individualPersonsValidityHeritier,
      setIndividualPersonsValidityHeritier,
      individualPersonsCheckedHeritier,
      setIndividualPersonsCheckedHeritier,

      reducedIndividualPerson,
      setReducedIndividualPerson,
      reducedIndividualPersonValidity,
      setReducedIndividualPersonValidity,
      reducedIndividualPersonChecked,
      setReducedIndividualPersonChecked,

      legalEntity,
      setLegalEntity,
      legalEntityValidity,
      setLegalEntityValidity,
      legalEntityChecked,
      setLegalEntityChecked,

      reducedLegalEntity,
      setReducedLegalEntity,
      reducedLegalEntityValidity,
      setReducedLegalEntityValidity,
      reducedLegalEntityChecked,
      setReducedLegalEntityChecked,

      manager,
      setManager,
      managerValidity,
      setManagerValidity,
      managerChecked,
      setManagerChecked,

      // Affected Individuals List
      affectedIndividuals,
      setAffectedIndividuals,
      affectedIndividualsValidity,
      setAffectedIndividualsValidity,
      affectedIndividualsChecked,
      setAffectedIndividualsChecked,
      typeAffectedIndividualsData,
      setTypeAffectedIndividualsData,

      managerWithQuality,
      setManagerWithQuality,
      managerWithQualityValidity,
      setManagerWithQualityValidity,
      managerWithQualityChecked,
      setManagerWithQualityChecked,

      signingOfTheStatus,
      setSigningOfTheStatus,
      signingOfTheStatusValidity,
      setSigningOfTheStatusValidity,
      signingOfTheStatusChecked,
      setSigningOfTheStatusChecked,

      //Tax Service Registration
      taxServiceRegistration,
      setTaxServiceRegistration,
      taxServiceRegistrationValidity,
      setTaxServiceRegistrationValidity,
      taxServiceRegistrationChecked,
      setTaxServiceRegistrationChecked,

      // new statutory auditor for Departure with replacement of the statutory auditor and alternate (ManagerType)
      newStatutoryAuditor,
      setNewStatutoryAuditor,
      newStatutoryAuditorValidity,
      setNewStatutoryAuditorValidity,
      newStatutoryAuditorChecked,
      setNewStatutoryAuditorChecked,

      // former statutory auditor alternate for Departure with replacement of the statutory auditor and alternate (ReduceManager)
      formerStatutoryAuditor,
      setFormerStatutoryAuditor,
      formerStatutoryAuditorValidity,
      setFormerStatutoryAuditorValidity,
      formerStatutoryAuditorChecked,
      setFormerStatutoryAuditorChecked,

      // new reduced statutory auditor for Departure with replacement of the statutory auditor and alternate(ManagerType)
      newAlternateAuditor,
      setNewAlternateAuditor,
      newAlternateAuditorValidity,
      setNewAlternateAuditorValidity,
      newAlternateAuditorChecked,
      setNewAlternateAuditorChecked,
      typeNewAlternateAuditorData,
      setTypeNewAlternateAuditorData,

      // former reduced statutory auditor alternate for Departure with replacement of the statutory auditor and alternate (ReduceManager)
      formerAlternateAuditor,
      setFormerAlternateAuditor,
      formerAlternateAuditorValidity,
      setFormerAlternateAuditorValidity,
      formerAlternateAuditorChecked,
      setFormerAlternateAuditorChecked,
      typeFormerAlternateAuditorData,
      setTypeFormerAlternateAuditorData,

      liquidators,
      setLiquidators,
      liquidatorValidity,
      setLiquidatorValidity,
      liquidatorChecked,
      setLiquidatorChecked,

      reducedManager,
      setReducedManager,
      reducedManagerValidity,
      setReducedManagerValidity,
      reducedManagerChecked,
      setReducedManagerChecked,

      reducedManagers,
      setReducedManagers,
      reducedManagersValidity,
      setReducedManagersValidity,
      reducedManagersChecked,
      setReducedManagersChecked,

      oldSecondAdministrator,
      setOldSecondAdministrator,
      oldSecondAdministratorValidity,
      setOldSecondAdministratorValidity,
      oldSecondAdministratorChecked,
      setOldSecondAdministratorChecked,
      typeOldAdministratorData,
      setTypeOldAdministratorData,

      secondManagerWithRepresentative,
      setSecondManagerWithRepresentative,
      secondManagerWithRepresentativeValidity,
      setSecondManagerWithRepresentativeValidity,
      secondManagerWithRepresentativeChecked,
      setSecondManagerWithRepresentativeChecked,
      typeSecondManagerWithRepresentativeData,
      setTypeSecondManagerWithRepresentativeData,

      companyName,
      setCompanyName,
      companyNameValidity,
      setCompanyNameValidity,
      companyNameChecked,
      setCompanyNameChecked,

      legalEntityofficiant,
      setlegalEntityofficiant,
      companyNameofficiant,
      setcompanyNameofficiant,
      mode,
      setmode,

      Tribunal,
      setTribunal,

      heritier,
      setheritier,

      companyNameUpdate,
      setCompanyNameUpdate,
      companyNameUpdateValidity,
      setCompanyNameUpdateValidity,
      companyNameUpdateChecked,
      setCompanyNameUpdateChecked,

      statusSignature,
      setStatusSignature,
      statusSignatureValidity,
      setStatusSignatureValidity,
      statusSignatureChecked,
      setStatusSignatureChecked,

      theSociety,
      setTheSociety,
      theSocietyValidity,
      setTheSocietyValidity,
      theSocietyChecked,
      setTheSocietyChecked,

      headOfficeAddress,
      setHeadOfficeAddress,
      headOfficeAddressValidity,
      setHeadOfficeAddressValidity,
      headOfficeAddressChecked,
      setHeadOfficeAddressChecked,

      managers,
      setManagers,
      managersChecked,
      setManagersChecked,
      managersValidity,
      setManagersValidity,

      // New Last Name
      newLastName,
      setNewLastName,
      newLastNameValidity,
      setNewLastNameValidity,
      newLastNameChecked,
      setNewLastNameChecked,
      typeNewLastNameData,
      setTypeNewLastNameData,

      associates,
      setAssociates,
      associatesValidity,
      setAssociatesValidity,
      associatesChecked,
      setAssociatesChecked,

      managersWithRepresentative,
      setManagersWithRepresentative,
      managersWithRepresentativeValidity,
      setManagersWithRepresentativeValidity,
      managersWithRepresentativeChecked,
      setManagersWithRepresentativeChecked,

      managersWithRepresentativeList,
      setManagersWithRepresentativeList,
      managersWithRepresentativeListValidity,
      setManagersWithRepresentativeListValidity,
      managersWithRepresentativeListChecked,
      setManagersWithRepresentativeListChecked,

      managerWithRepresentative,
      setManagerWithRepresentative,
      managerWithRepresentativeValidity,
      setManagerWithRepresentativeValidity,
      managerWithRepresentativeChecked,
      setManagerWithRepresentativeChecked,

      statutoryAuditorWithRepresentative,
      setStatutoryAuditorWithRepresentative,
      statutoryAuditorWithRepresentativeValidity,
      setStatutoryAuditorWithRepresentativeValidity,
      statutoryAuditorWithRepresentativeChecked,
      setStatutoryAuditorWithRepresentativeChecked,

      deputyAuditorWithRepresentative,
      setDeputyAuditorWithRepresentative,
      deputyAuditorWithRepresentativeValidity,
      setDeputyAuditorWithRepresentativeValidity,
      deputyAuditorWithRepresentativeChecked,
      setDeputyAuditorWithRepresentativeChecked,

      councilMeeting,
      setCouncilMeeting,
      councilMeetingValidity,
      setCouncilMeetingValidity,
      councilMeetingChecked,
      setCouncilMeetingChecked,

      identity,
      setIdentity,
      identityValidity,
      setIdentityValidity,
      identityChecked,
      setIdentityChecked,

      decision,
      setDecision,
      decisionValidity,
      setDecisionValidity,
      decisionChecked,
      setDecisionChecked,

      decisionWithQuality,
      setDecisionWithQuality,
      decisionWithQualityValidity,
      setDecisionWithQualityValidity,
      decisionWithQualityChecked,
      setDecisionWithQualityChecked,

      decisionWithQualityAndEffectiveDate,
      setDecisionWithQualityAndEffectiveDate,
      decisionWithQualityAndEffectiveDateValidity,
      setDecisionWithQualityAndEffectiveDateValidity,
      decisionWithQualityAndEffectiveDateChecked,
      setDecisionWithQualityAndEffectiveDateChecked,

      decisionWithEffectiveDate,
      setDecisionWithEffectiveDate,
      decisionWithEffectiveDateValidity,
      setDecisionWithEffectiveDateValidity,
      decisionWithEffectiveDateChecked,
      setDecisionWithEffectiveDateChecked,

      DurationDateDébut,
      setDurationDateDébut,
      durationDateDébutValidity,
      setdurationDateDébutValidity,
      durationDateDébutChecked,
      setDurationDateDébutChecked,

      address,
      setAddress,
      addressValidity,
      setAddressValidity,
      addressChecked,
      setAddressChecked,

      addressedeces,
      setAddressdeces,

      locationOppositionsRegistry,
      setLocationOppositionsRegistry,
      locationOppositionsRegistryValidity,
      setLocationOppositionsRegistryValidity,
      locationOppositionsRegistryChecked,
      setLocationOppositionsRegistryChecked,

      validityOppositionLocation,
      setValidityOppositionLocation,
      validityOppositionLocationValidity,
      setValidityOppositionLocationValidity,
      validityOppositionLocationChecked,
      setValidityOppositionLocationChecked,

      date,
      setDate,
      dateValidity,
      setDateValidity,
      dateChecked,
      setDateChecked,

      dateOfReceipt,
      setDateOfReceipt,
      dateOfReceiptValidity,
      setDateOfReceiptValidity,
      dateOfReceiptChecked,
      setDateOfReceiptChecked,

      dateOfFiling,
      setDateOfFiling,
      dateOfFilingValidity,
      setDateOfFilingValidity,
      dateOfFilingChecked,
      setDateOfFilingChecked,

      dateOfWill,
      setDateOfWill,
      dateOfWillValidity,
      setDateOfWillValidity,
      dateOfWillChecked,
      setDateOfWillChecked,

      dateNotary,
      setdateNotary,
      dateValidityNotary,
      setdateValidityNotary,
      dateCheckedNotary,
      setdateCheckedNotary,

      datedeces,
      setdatedeces,
      datecheckedDeces,
      setdatecheckedDeces,
      dateValidityDeces,
      setDateValidityDeces,

      personneeDecede,
      setpersonneeDecede,
      personneeDecedechecked,
      setpersonneeDecedechecked,
      personneeDecedeValidity,
      setpersonneeDecedeValidity,

      dateofficiant,
      setDateofficiant,

      checkedofficiant,
      setcheckedofficiant,
      officiantValidity,
      setofficiantValidity,

      tribunalValidity,
      settribunalValidity,

      heritierValidity,
      setheritierValidity,

      checkedtribunal,
      setcheckedtribunal,
      DateTribunal,
      setDateTribunal,

      checkedHeritier,
      setcheckedHeritier,

      datesignature,
      setDatesignature,
      dateValiditysignature,
      setDateValiditysignature,
      dateCheckedsignature,
      setDateCheckedsignature,
      dateOfBirth,
      setDateOfBirth,
      dateOfBirthValidity,
      setDateOfBirthValidity,
      dateOfBirthChecked,
      setDateOfBirthChecked,

      registrationDate,
      setRegistrationDate,
      registrationDateValidity,
      setRegistrationDateValidity,
      registrationDateChecked,
      setRegistrationDateChecked,

      oldCapitalChange,
      setOldCapitalChange,
      oldCapitalChangeValidity,
      setOldCapitalChangeValidity,
      oldCapitalChangeChecked,
      setOldCapitalChangeChecked,

      newCapitalChange,
      setNewCapitalChange,
      newCapitalChangeValidity,
      setNewCapitalChangeValidity,
      newCapitalChangeChecked,
      setNewCapitalChangeChecked,

      dateWhithEffectiveDate,
      setDateWhithEffectiveDate,
      dateWhithEffectiveDateValidity,
      setDateWhithEffectiveDateValidity,
      dateWhithEffectiveDateChecked,
      setDateWhithEffectiveDateChecked,

      auditorsChange,
      setAuditorsChange,

      notaryData,
      setNotaryData,

      // Change Of Capital
      changeCapital,
      setChangeCapital,
      changeCapitalValidity,
      setChangeCapitalValidity,
      changeCapitalChecked,
      setChangeCapitalChecked,

      // Change Of Capital Input
      transfertAmount,
      setTransfertAmount,
      transfertAmountValidity,
      setTransfertAmountValidity,
      transfertAmountChecked,
      setTransfertAmountChecked,

      // Change Of Social Object
      changeSocialObject,
      setChangeSocialObject,
      changeSocialObjectValidity,
      setChangeSocialObjectValidity,
      changeSocialObjectChecked,
      setChangeSocialObjectChecked,

      // Managing Director List
      generalManagers,
      setGeneralManagers,
      generalManagersValidity,
      setGeneralManagersValidity,
      generalManagersChecked,
      setGeneralManagersChecked,
      typeGeneralManagersData,
      setTypeGeneralManagersData,

      // Managing with quality
      generalManagersWithQualite,
      setGeneralManagersWithQualite,
      generalManagersWithQualiteValidity,
      setGeneralManagersWithQualiteValidity,
      generalManagersWithQualiteChecked,
      setGeneralManagersWithQualiteChecked,
      typeGeneralManagersWithQualiteData,
      setTypeGeneralManagersWithQualiteData,

      reducedGeneralManagersWithQualite,
      setReducedGeneralManagersWithQualite,
      reducedGeneralManagersWithQualiteValidity,
      setReducedGeneralManagersWithQualiteValidity,
      reducedGeneralManagersWithQualiteChecked,
      setReducedGeneralManagersWithQualiteChecked,

      // executiveOfficers
      executiveOfficers, setExecutiveOfficers,
      executiveOfficersValidity, setExecutiveOfficersValidity,
      executiveOfficersChecked, setExecutiveOfficersChecked,
      typeExecutiveOfficersData, setTypeExecutiveOfficersData,

      // statutoryAuditor
      statutoryAuditor, setStatutoryAuditor,
      statutoryAuditorValidity, setStatutoryAuditorValidity,
      statutoryAuditorChecked, setStatutoryAuditorChecked,
      typeStatutoryAuditorData, setTypeStatutoryAuditorData,

      // AlternateAuditor
      alternateAuditor, setAlternateAuditor,
      alternateAuditorValidity, setAlternateAuditorValidity,
      alternateAuditorChecked, setAlternateAuditorChecked,
      typeAlternateAuditorData, setTypeAlternateAuditorData,

      absorbedCompany, setAbsorbedCompany,
      absorbedCompanyChecked, setAbsorbedCompanyChecked,
      absorbedCompanyValidity, setAbsorbedCompanyValidity,

      absorbingCompany, setAbsorbingCompany,
      absorbingCompanyChecked, setAbsorbingCompanyChecked,
      absorbingCompanyValidity, setAbsorbingCompanyValidity,

      leaderChange, setLeaderChange,
      leaderChangeValidity, setLeaderChangeValidity,
      leaderChangeChecked, setLeaderChangeChecked,

      partnerChange, setPartnerChange,
      partnerChangeValidity, setPartnerChangeValidity,
      partnerChangeChecked, setPartnerChangeChecked,

      typeGeneralManagerData,
      setTypeGeneralManagerData,

      liquidationHeadquarter,
      setLiquidationHeadquarter,

      typeAddress,
      setTypeAddress,

      typeHeirsData,
      setTypeHeirsData,

      clause,
      setClause,

      admission,
      setAdmission,

      admissionDescriptionText,
      setAdmissionDescriptionText,
      admissionDescriptionTextValidity,
      setAdmissionDescriptionTextValidity,
      admissionDescriptionTextChecked,
      setAdmissionDescriptionTextChecked,

      clauseDescriptionText,
      setClauseDescriptionText,
      clauseDescriptionTextValidity,
      setClauseDescriptionTextValidity,
      clauseDescriptionTextChecked,
      setClauseDescriptionTextChecked,

      typeTransformationOfSociety,
      setTypeTransformationOfSociety,

      typeTransformationOfSocietySARL,
      setTypeTransformationOfSocietySARL,

      inputGeneralDirector,
      setInputGeneralDirector,

      // MULTIPLE CHANGES
      // manager and presidency change
      managerAndPresidencyChange,
      setManagerAndPresidencyChange,

      // Denomination change
      companyNameChange,
      setCompanyNameChange,

      // Social object change
      socialObjectChange,
      setSocialObjectChange,

      // Social capital change
      socialCapitalChange,
      setSocialCapitalChange,

      // Duration change
      durationChange,
      setDurationChange,

      // Auditor change
      auditorChange,
      setAuditorChange,

      // Seat transfert change
      seatTransfertChange,
      setSeatTransfertChange,

      // manager and presidency change effective date
      presidencyChangeEffectiveDate, setPresidencyChangeEffectiveDate,
      presidencyChangeEffectiveDateValidity, setPresidencyChangeEffectiveDateValidity,
      presidencyChangeEffectiveDateChecked, setPresidencyChangeEffectiveDateChecked,

      // company name change effective date
      companyNameChangeEffectiveDate, setCompanyNameChangeEffectiveDate,
      companyNameChangeEffectiveDateValidity, setCompanyNameChangeEffectiveDateValidity,
      companyNameChangeEffectiveDateChecked, setCompanyNameChangeEffectiveDateChecked,

      // social object change effective date
      socialObjectChangeEffectiveDate, setSocialObjectChangeEffectiveDate,
      socialObjectChangeEffectiveDateValidity, setSocialObjectChangeEffectiveDateValidity,
      socialObjectChangeEffectiveDateChecked, setSocialObjectChangeEffectiveDateChecked,

      // social capital change effective date
      socialCapitalChangeEffectiveDate, setSocialCapitalChangeEffectiveDate,
      socialCapitalChangeEffectiveDateValidity, setSocialCapitalChangeEffectiveDateValidity,
      socialCapitalChangeEffectiveDateChecked, setSocialCapitalChangeEffectiveDateChecked,

      // duration change effective date
      durationChangeEffectiveDate, setDurationChangeEffectiveDate,
      durationChangeEffectiveDateValidity, setDurationChangeEffectiveDateValidity,
      durationChangeEffectiveDateChecked, setDurationChangeEffectiveDateChecked,

      // duration change date
      durationChangeDate, setDurationChangeDate,
      durationChangeDateValidity, setDurationChangeDateValidity,
      durationChangeDateChecked, setDurationChangeDateChecked,

      // auditor change effective date
      auditorChangeEffectiveDate, setAuditorChangeEffectiveDate,
      auditorChangeEffectiveDateValidity, setAuditorChangeEffectiveDateValidity,
      auditorChangeEffectiveDateChecked, setAuditorChangeEffectiveDateChecked,

      // seat transfert change effective date
      seatTransfertChangeEffectiveDate, setseatTransfertChangeEffectiveDate,
      seatTransfertChangeEffectiveDateValidity, setseatTransfertChangeEffectiveDateValidity,
      seatTransfertChangeEffectiveDateChecked, setseatTransfertChangeEffectiveDateChecked,

      // reduced statutoryAuditor
      reducedStatutoryAuditor, setReducedStatutoryAuditor,
      reducedStatutoryAuditorValidity, setReducedStatutoryAuditorValidity,
      reducedStatutoryAuditorChecked, setReducedStatutoryAuditorChecked,

      typeRegistrationData,
      setTypeRegistrationData,

      typeOppositionData,
      setTypeOppositionData,


      // cédant
      sellerManager, setSellerManager,
      sellerManagerValidity, setSellerManagerValidity,
      sellerManagerChecked, setSellerManagerChecked,

      // acquéreur
      buyerManager, setBuyerManager,
      buyerManagerValidity, setBuyerManagerValidity,
      buyerManagerChecked, setBuyerManagerChecked,


      // activité du fonds
      fundActivity, setFundActivity,
      fundActivityValidity, setFundActivityValidity,
      fundActivityChecked, setFundActivityChecked,

      // actéléments du fonds
      fundElements, setFundElements,
      fundElementsValidity, setFundElementsValidity,
      fundElementsChecked, setFundElementsChecked,

      // Death Related Info
      deathRelatedInfo, setDeathRelatedInfo,
      deathRelatedInfoValidity, setDeathRelatedInfoValidity,
      deathRelatedInfoChecked, setDeathRelatedInfoChecked,

      fullName, setFullName,

      // Family Situation
      typeFamilySituationData, setTypeFamilySituationData,
       // déclaration d'insaisissabilité
      registrationReference, setRegistrationReference,
      registrationReferenceValidity, setRegistrationReferenceValidity,
      registrationReferenceChecked, setRegistrationReferenceChecked,

      notaryContact, setNotaryContact,
      notaryContactValidity, setNotaryContactValidity,
      notaryContactChecked, setNotaryContactChecked,

      applicant, setApplicant ,
      applicantValidity, setApplicantValidity,
      applicantChecked, setApplicantChecked,
      
      mariageContract, setMariageContract,

      residentialAddress, setResidentialAddress,
      residentialAddressValidity, setResidentialAddressValidity,
      residentialAddressChecked, setResidentialAddressChecked,

      mainResidenceAddress, setMainResidenceAddress,
      mainResidenceAddressValidity, setMainResidenceAddressValidity,
      mainResidenceAddressChecked, setMainResidenceAddressChecked,

      deathDate, setDeathDate,

      // changement de régime matrimonial
      spouseNumberOne, setSpouseNumberOne,
      spouseNumberOneValidity, setSpouseNumberOneValidity,
      spouseNumberOneChecked, setSpouseNumberOneChecked,

      spouseOneBirth, setSpouseOneBirth,
      spouseOneBirthValidity, setSpouseOneBirthValidity,
      spouseOneBirthChecked, setSpouseOneBirthChecked,
      
      spouseNumberTwo, setSpouseNumberTwo,
      spouseNumberTwoValidity, setSpouseNumberTwoValidity,
      spouseNumberTwoChecked, setSpouseNumberTwoChecked,

      spouseTwoBirth, setSpouseTwoBirth,
      spouseTwoBirthValidity, setSpouseTwoBirthValidity,
      spouseTwoBirthChecked, setSpouseTwoBirthChecked,

      spousesAddress, setSpousesAddress,
      spousesAddressValidity, setSpousesAddressValidity,
      spousesAddressChecked, setSpousesAddressChecked,

      previousRegime, setPreviousRegime,
      previousRegimeValidity, setPreviousRegimeValidity,
      previousRegimeChecked, setPreviousRegimeChecked,

      newRegime, setNewRegime,

      typeNotaryData, setTypeNotaryData,

      contractDate, setcontractDate,
      
      officiatingNotary, setOfficiatingNotary,
      officiatingNotaryValidity, setOfficiatingNotaryValidity,
      officiatingNotaryChecked, setOfficiatingNotaryChecked,
      
      oppositionsNotary, setOppositionsNotary,
      oppositionsNotaryValidity, setOppositionsNotaryValidity,
      oppositionsNotaryChecked, setOppositionsNotaryChecked,

      denomination, setDenomination,
      legalForm, setLegalForm ,
      clientReference, setClientReference ,
      texteAnnonce, setTexteAnnonce,

      logos, setLogos,

      // User Information
      userName, setUserName,
      userFirstname, setUserFirstname,

      profilePicture, setProfilePicture,

      
      // announcement logoID and header
      entete, setEntete,
      floid, setFloid,
      logoLibelle, setLogoLibelle,
      choix, setChoix,
      pointsToUse, setPointsToUse,
      userPoints, setUserPoints,

      status,setUserStatus

    }}>
      {children}
    </AppContext.Provider>
  );
};
